import { React, useState, useEffect, useContext, useRef } from 'react'
import { Button } from 'bootstrap'
import "../css/PagesCommonStyle.css"
import { faMagnifyingGlass, faPrint, faCircleCheck, faShieldHalved } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileExcel, faFilePdf, faTrashCan, faFile } from '@fortawesome/free-regular-svg-icons'
import { useSelector, useDispatch } from 'react-redux';
import { faTriangleExclamation, faStar, faCircleInfo, faArrowsRotate, faAnglesDown, faAnglesUp, faXmark, faArrowRight, faSpinner } from '@fortawesome/free-solid-svg-icons'
import { APIConstants, IntelliBillConstants, ClaimApprovalConstants, ClaimStatusConstants, CommonAPIConstants, PostingpaymentsConstants, FilesAPIConstants, RemittanceConstants } from '../utilities/Constants'
import * as XLSX from 'xlsx';
import { setUser } from '../redux/actions/userActions'
import { Link } from 'react-router-dom'
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { format } from 'date-fns';
import { FixedSizeList as List } from 'react-window'
import Draggable from 'react-draggable'



const RemittanceClaimCounts = ({ selectedItem }) => {

    const getCurrentDate = () => {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const day = String(today.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    // Default value for the input is the current date
    const defaultDate = getCurrentDate();
    const defaultFromDate = new Date('2015-01-01');

    const today = new Date();
    const formatCurDate = format(today, 'MM/dd/yyyy');

    const [isHideChecked, setIsHideChecked] = useState(false);
    const [updatedTabledata, setUpdatedTableData] = useState([]);
    const [error, setError] = useState(null);
    const [startDate, setStartDate] = useState(defaultDate, defaultFromDate); // State to store start date
    const [endDate, setEndDate] = useState(defaultDate);     // State to store end date
    const [loading, setLoading] = useState(false);


    const ServiceLocValues = [
        { TextField: 'Office - 11', ValueField: '11' },
        { TextField: 'Home - 12', ValueField: '12' },
        { TextField: 'SUD - 57', ValueField: '57' },
        { TextField: 'Lab - 81', ValueField: '81' },


    ];

    const [ServiceLocations, setServiceLocations] = useState([]);
    const [selectedCMS33a, setSelectedCMS33a] = useState('0');
    const [selectedCMS33b, setSelectedCMS33b] = useState('0');
    const [selectedBillingNPI, setSelectedBillingNPI] = useState('0');
    const [selectedPracticeProvider, setSelectedPracticeProvider] = useState('0');
    const [selectedProvidersCategory, setSelectedProvidersCategory] = useState('0');
    const [selectedSearchFilter, setSelectedSearchFilter] = useState('9');
    const [selectedLocation, setSelectedLocation] = useState('-1');
    const [selectedStatusRadioButton, setSelectedStatusRadioButton] = useState('');
    const [selectedCheckedRadioButton, setSelectedCheckedRadioButton] = useState('0');
    const [selectedServiceLocation, setSelectedServicelocation] = useState('0');
    const [selectedFilterProvider, setSelectedFilterProvider] = useState('0');


    const [locations, setLocations] = useState([]);
    const [cms33aData, setCMS33aData] = useState([]);
    const [cms33bData, setCMS33bData] = useState([]);
    const [providerCategory, setProviderCategory] = useState([]);
    const [searchFilterData, setSearchFilterData] = useState([]);
    const [practiceProvider, setPracticeProvider] = useState([]);
    const [statusRadioButton, setStatusRadioButton] = useState([]);
    const [checkedRadioButton, setCheckedRadioButton] = useState([]);

    const [BillingNPIs, setBillingNPIs] = useState([]);

    const [searchText, setSearchText] = useState('');

    const [searchPatientText, setSearchPatientText] = useState('');
    const [searchProvidersText, setSearchProvidersText] = useState('');
    const [searchInsuranceText, setSearchInsuranceText] = useState('');
    const [selectedFilter, setSelectedFilter] = useState('');
    const [suggestions, setSuggestions] = useState([]);
    const [isTextBoxDisabled, setIsTextBoxDisabled] = useState(true);
    const [issuggestionBoxDisabled, setIsSuggestionBoxDisabled] = useState(true);
    const [sPatID, setSPatID] = useState('');
    const [sInsID, setSInsID] = useState('');
    const [sClaimStatus, setsClaimStatus] = useState('');
    const [rowsValidation, setRowsValidation] = useState('');
    const [isChecked, setIsChecked] = useState(false);



    const [tableDetails, setTableDetails] = useState([]);
    const [tableInsDetails, setTableInsDetails] = useState([]);
    const [checkEligibility, setCheckEligibility] = useState([]);
    const [selectedClaims, setSelectedClaims] = useState([]);
    const [selectAllDropdown, setSelectAllDropdown] = useState([]);
    const [checkboxes, setCheckboxes] = useState();

    const [searchPatientData, setSearchPatientData] = useState([]);
    const [suggestionProviders, setSuggestionProviders] = useState('');
    const [suggestionInsurance, setSuggestionInsurance] = useState('');
    const [patientList, setPatientList] = useState('');




    const [selectedRows, setSelectedRows] = useState([]);
    const [selectedSendRows, setSelectedSendRows] = useState([]);
    const [selectedLocationRows, setSelectedLocationRows] = useState([]);
    const [selectedValueLocRows, setSelectedValueLocRows] = useState([]);
    const [UnitChargeRows, setUnitChargeRows] = useState([]);
    const [unitCheckbox, setUnitCheckbox] = useState([]);
    const [diag4AllCheckbox, setDiag4AllCheckbox] = useState([]);
    const [diag3AllCheckbox, setDiag3AllCheckbox] = useState([]);
    const [diag2AllCheckbox, setDiag2AllCheckbox] = useState([]);
    const [diag1AllCheckbox, setDiag1AllCheckbox] = useState([]);
    const [mod3AllCheckbox, setMod3AllCheckbox] = useState([]);
    const [mod2AllCheckbox, setMod2AllCheckbox] = useState([]);
    const [mod1AllCheckbox, setMod1AllCheckbox] = useState([]);
    const [cptAllCheckbox, setCptAllCheckbox] = useState([]);
    const [providerAllCheckbox, setProviderAllCheckbox] = useState([]);
    const [insuranceAllCheckbox, setInsuranceAllCheckbox] = useState([]);
    const [filteredTableDetails, setFilteredTableDetails] = useState(tableDetails);


    const [searchByPatient, setSearchByPatient] = useState('');
    const [searchByDOB, setSearchByDOB] = useState('');
    const [searchByInsurance, setSearchByInsurance] = useState('');
    const [searchByProvider, setSearchByProvider] = useState('');
    const [searchByCPT, setSearchByCPT] = useState('');
    const [searchByDOS, setSearchByDOS] = useState('');
    const [searchByPostingDate, setSearchByPostingDate] = useState('');
    const [searchBySubmitdate, setSearchBySubmitdate] = useState('');
    const [searchBySecSubmitdate, setSearchBySecSubmitdate] = useState('');
    const [searchByICD, setSearchByICD] = useState('');
    const [searchByTotalCharge, setSearchByTotalCharge] = useState('');
    const [searchByStatus, setSearchByStatus] = useState('');
    const [searchByRecievedCharge, setSearchByRecievedCharge] = useState('');
    const [searchBySubmitter, setSearchBySubmitter] = useState('');
    const [searchByClaim, setSearchByClaim] = useState('');
    const [searchByRcvdCharge, setSearchByRcvdCharge] = useState('');
    const [searchByWriteOffValue, setSearchByWriteOffValue] = useState('');
    const [searchByAdminWriteOffValue, setSearchByAdminWriteOffValue] = useState('');
    const [searchByBalance, setSearchByBalance] = useState('');
    const [searchByCheckNum, setSearchByCheckNum] = useState('');
    const [searchByCheckDate, setSearchByCheckDate] = useState('');
    const [searchByPayerRef, setSearchByPayerRef] = useState('');
    const [searchByDeductible, setSearchByDeductible] = useState('');
    const [searchByPatientRes, setSearchByPatientRes] = useState('');
    const [searchByClearingHouse, setSearchByClearingHouse] = useState('');
    const [searchByUpdatedBy, setSearchByUpdatedBy] = useState('');
    const [searchBySubmittedBy, setSearchBySubmittedBy] = useState('');


    const [searchBySecRcvdCharge, setSearchBySecRcvdCharge] = useState('');
    const [searchBySecInsurance, setSearchBySecInsurance] = useState('');
    const [searchBySecCheckNum, setSearchBySecCheckNum] = useState('');
    const [searchBySecCheckDate, setSearchBySecCheckDate] = useState('');
    const [searchBySecPayerRef, setSearchBySecPayerRef] = useState('');
    const [searchByAdjustmentAmt, setSearchByAdjustmentAmt] = useState('');
    const [searchBySecPendingAmt, setSearchBySecPendingAmt] = useState('');

    const [selectedTextField, setSelectedTextField] = useState('');
    const [selectedValueField, setSelectedValueField] = useState('');
    const [selectedRecValue, setSelectedRecValue] = useState('all'); // Default value is 25
    const [totalRecords, setTotalRecords] = useState(0);
    const [displayedRecords, setDisplayedRecords] = useState([]);
    const [selectedDropdownValue, setSelectedDropdownValue] = useState('DOS');

    const [showSelectErrorModal, setShowSelectErrorModal] = useState(false);
    const [showConfirmSaveModal, setShowConfirmSaveModal] = useState(false);
    const [showVerifiedSaveModal, setShowVerifiedSaveModal] = useState(false);
    const [showServiceErrorModal, setShowServiceErrorModal] = useState(false);
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [deleteSuccessModal, setDeleteSuccessModal] = useState(false);
    const [closeClaimsModal, setCloseClaimsModal] = useState(false);
    const [savedRowCount, setSavedRowCount] = useState(0);
    const [deleteRowCount, setDeleteRowCount] = useState(0);
    const [successTimer, setSuccessTimer] = useState(5000);

    const [appointmentDates, setAppointmentDates] = useState([]);
    const [selectLocationID, setSelectLocationID] = useState('-1');
    const [showFilters, setShowFilters] = useState(false);
    const [showDetails, setShowDetails] = useState(false);

    const [claimservices, setClaimServices] = useState([]);
    const [selectedCptValue, setSelectedCptValue] = useState('');
    const [cptValueList, setCptValueList] = useState([]);
    const [selectedCPTCode, setSelectedCPTCode] = useState('');
    const [insOrPatFilter, setInsOrPatFilter] = useState('updatedby');
    const [practiceBillingNPIs, setPracticeBillingNPIs] = useState([]);
    const [selectpracticeBillingNPIs, setSelectPracticeBillingNPIs] = useState('');
    const [selectedViewType, setSelectedViewType] = useState('0');
    const [selectedClaimService, setSelectedClaimService] = useState('0');
    const [isClaimClosed, setIsClaimClosed] = useState('false');

    const [claimFilterRecCountsTableData, setClaimFilterRecCountsTableData] = useState([]);
    const [claimRecCountsTableData, setClaimRecCountsTableData] = useState(claimFilterRecCountsTableData);
    const [defaultUpdatedBy, setDefaultUpdatedBy] = useState('Test Biller');

    const [checkedServices, setCheckedServices] = useState([]);
    const [isNoServiceChecked, setIsNoServiceChecked] = useState(false);

    const [selectedPolicyRows, setSelectedPolicyRows] = useState([]);
    const [selectedSecInsuranceRows, setSelectedSecInsuranceRows] = useState([]);
    const [selectedAdminWriteRows, setSelectedAdminWriteRows] = useState([]);
    const [selectedWriteOffRows, setSelectedWriteOffRows] = useState([]);
    const [selectedResubmitRows, setSelectedResubmitRows] = useState([]);
    const [transactionCodes, setTransactionCodes] = useState([]);
    const [selectedTransactionCode, setSelectedTransactionCode] = useState('');
    const [verifiedData, setVerifiedData] = useState([]);
    const [selectedVerifiedData, setSelectedVerifiedData] = useState([]);
    const [billingNpiValue, setBillingNpiValue] = useState('');
    const [claimId, setClaimId] = useState('');
    const [cptCode, setCptCode] = useState('');
    const [dos, setDos] = useState('');
    const [savingData, setSavingData] = useState(false);
    const [dataSaved, setDataSaved] = useState(false);
    const [filterType, setFilterType] = useState('all');
    const [claimDOS, setClaimDOS] = useState('');
    const [isTotal, setIsTotal] = useState(false);

    const [isClaimChecked, setIsClaimChecked] = useState(true);
    const [isSubmitChecked, setIsSubmitChecked] = useState(true);
    const [isNonSubmitChecked, setIsNonSubmitChecked] = useState(true);
    const [isSentChecked, setIsSentChecked] = useState(true);
    const [isPaidChecked, setIsPaidChecked] = useState(true);
    const [isRecvdChecked, setIsRecvdChecked] = useState(true);
    const [isDeniedChecked, setIsDeniedChecked] = useState(true);
    const [isRejectedChecked, setIsRejectedChecked] = useState(true);
    const [isForwardChecked, setIsForwardChecked] = useState(true);
    const [isPostedChecked, setIsPostedChecked] = useState(true);

    const [rcvdwriteOffValue, setRcvdWriteOffValue] = useState('0');

    const [claimRecvdChargeValue, setClaimRcvdChargeValue] = useState([]);
    const [claimWriteOffValue, setClaimWriteOffvalue] = useState([]);

    const [claimSecRecvdChargeValue, setSecClaimRcvdChargeValue] = useState([]);

    const [deductibleAmt, setDeductible] = useState([]);
    const [patientRes, setPatientRes] = useState([]);
    const [adjustmentAmt, setAdjustmentAmt] = useState([]);
    const [secPendingAmt, setsecPendingAmt] = useState([]);

    const [isDataUpdated, setIsDataUpdated] = useState(false);
    const [cptChequeNumber, setcptChequeNumber] = useState([]);
    const [cptChequeDate, setCptChequeDate] = useState([]);
    const [isFocused, setIsFocused] = useState(false);
    const [checkDate, setCheckDate] = useState('');
    const [formatCheckDate, setFormatCheckDate] = useState('');
    const [claimPayerRefID, setClaimPayerRefID] = useState([]);
    const [claimNotes, setClaimNotes] = useState([]);

    const [cptSecChequeNumber, setcptsecChequeNumber] = useState([]);
    const [cptSecChequeDate, setCptSecChequeDate] = useState([]);
    const [secClaimPayerRefID, setSecClaimPayerRefID] = useState([]);

    const [checkEligibilityColor, setCheckEligibilityColor] = useState('');
    const [isLoading, setIsLoading] = useState('');
    const [isInStatus, setIsInStatus] = useState(false);

    const [payRefColor, setPayRefColor] = useState(false);
    const [activeRow, setActiveRow] = useState(null);
    const [selectedServiceIDs, setSelectedServiceIDs] = useState([]);
    const [prevFilter, setPrevFilter] = useState('');
    const [queryFilter, setQueryFilter] = useState('');
    const [statusFilter, setStatusFilter] = useState(null);
    const [selectedAllChecked, setSelectedAllChecked] = useState(false);
    const [selectAllWriteOffChecked, setSelectAllWriteOffChecked] = useState(false);
    const [selectAllAdminWriteChecked, setSelectAllAdminWriteChecked] = useState(false);
    const [selectAllResubmit, setSelectAllResubmit] = useState(false);
    const [selectedData, setSelectedData] = useState('');
    const [isPageLoad, setisPageLoad] = useState('1');
    const [searchByClaimDos, setSearchByClaimDos] = useState('');

    const [showDataModal, setShowDataModal] = useState(false);
    const [eventData, setEventData] = useState([]);
    const [selectedClaimID, setselectedClaimID] = useState([]);
    const [showFaxModal, setShowFaxModal] = useState(false);

    const [reGenerateData, setReGenerateData] = useState(false);
    const [rowState, setRowState] = useState({});
    const [isHidden, setIsHidden] = useState(false);
    const [selectedPatname, setselectedPatname] = useState('');
    const [selectedDOB, setselectedDOB] = useState('');
    const [isStartOpen, setIsStartOpen] = useState(false);
    const [isEndOpen, setIsEndOpen] = useState(false);
    const [disableCheckboxes, setDisableCheckboxes] = useState(false);

    const [claimID, setClaimID] = useState('');
    const [adjustmentCodeData, setadjustmentCodeData] = useState([]);


    const [totals, setTotals] = useState({
        totalUnits: 0,
        totalSubmitted: 0,
        totalReceived: 0,
        totalSecReceived: 0,
        totalAdjustmentAmt: 0,
        totalSecPendingAmt: 0,
        totalDeductible: 0,
        totalPatientRes: 0,
        totalWriteOff: 0,
        totalAdminWriteOff: 0,
        totalBalance: 0,

    });


    const [totalsClaims, setTotalsClaims] = useState({
        totalSubmitClaim: 0,
        totalNonSubmitted: 0,
        totalSent: 0,
        totalForwarded: 0,
        totalReceivedClaim: 0,
        totalSecReceivedClaim: 0,
        totalDeductibleClaim: 0,
        totalPosted: 0,
        totalPaid: 0,
        totalRejected: 0,
        totalDenied: 0
    });




    const dispatch = useDispatch();




    const userData = useSelector((state) => state.user.user);
    console.log('UserData1:', userData);

    localStorage.setItem('userData2', JSON.stringify(userData));


    var userPracticeID = userData ? userData.practiceID : null;

    var userId = userData ? userData.userID : null;

    const sAuthToken = useSelector((state) => state.user.token);

    console.log('selectedItem:', selectedItem);





    useEffect(() => {

        const initialCheckedServices = claimservices.map((item) => item.ServiceID);
        setCheckedServices(initialCheckedServices);
        setShowServiceErrorModal(false)
    }, [claimservices]);


    useEffect(() => {
        const selectedIds = checkedServices.filter((id) => id !== 0);
        setSelectedServiceIDs(selectedIds);
        setShowServiceErrorModal(false)
    }, [checkedServices]);





    const handleClaimServiceChange = (item) => {


        if (item.ServiceID === '0') {

            setCheckedServices(isNoServiceChecked ? [] : claimservices.map((service) => service.ServiceID));
        } else {

            const updatedServices = checkedServices.includes(item.ServiceID)
                ? checkedServices.filter((selectedId) => selectedId !== item.ServiceID)
                : [...checkedServices, item.ServiceID];
            setCheckedServices(updatedServices);

        }
        updateSelectedServiceIds();
    };




    const updateSelectedServiceIds = () => {
        const selectedIds = checkedServices.includes('0')
            ? checkedServices.filter((id) => id !== '0')
            : checkedServices;

        setSelectedServiceIDs(selectedIds);
    };









    useEffect(() => {
        let timerId;


        if (showSuccessModal || deleteSuccessModal) {
            // Start the timer when the success modal is shown
            timerId = setTimeout(() => {
                setShowSuccessModal(false);
                setDeleteSuccessModal(false);
                setShowServiceErrorModal(false);

            }, successTimer);
        }


        return () => {
            clearTimeout(timerId);
        };
    }, [showSuccessModal, successTimer, deleteSuccessModal]);


    const modalRef = useRef(null);





    useEffect(() => {

        const handleOutsideClick = (event) => {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                setShowConfirmSaveModal(false);
            }
        };

        // Add event listener
        document.addEventListener('mousedown', handleOutsideClick);
        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, []);









    const handleStartDateChange = (date) => {
        if (date) {
            const formattedDate = format(date, 'MM/dd/yyyy');
            setStartDate(formattedDate);
            setIsStartOpen(false)
            console.log("Selected start date:", formattedDate);
        } else {
            setStartDate(null);
        }
    };


    const handleEndDateChange = (date) => {

        if (date) {
            const formattedDate = format(date, 'MM/dd/yyyy');
            setEndDate(formattedDate);
            console.log("Selected End date:", formattedDate);
            setIsEndOpen(false)

        } else {
            setEndDate(null);
        }
    };



    const getMonths = (selectedYear) => {
        const currentYear = new Date().getFullYear();
        const currentMonth = new Date().getMonth();

        return Array.from({ length: 12 }, (v, k) => {
            if (selectedYear === currentYear && k > currentMonth) {
                return null;
            }
            return (
                <option key={k} value={k}>
                    {format(new Date(selectedYear, k), 'MMMM')}
                </option>
            );
        }).filter(option => option !== null);
    };








    const handleTodayClick = (dateType) => {
        const today = new Date();

        if (dateType === "start" && startDate) {
            setStartDate(today);

            setIsStartOpen(false);
        }

        if (dateType === "end" && endDate) {
            setEndDate(today);
            setIsEndOpen(false);
        }
    };



    const CalendarContainer = ({ children }) => (
        <div style={{ zIndex: '99px', backgroundColor: 'white', border: '1px solid lightgray' }}>
            {children}
            <div style={{ justifyContent: 'center', padding: '10px', borderTop: '1px solid #ddd', marginLeft: '65px' }}>
                <button type="button" className='today-btn' onClick={() => handleTodayClick("end")}>
                    Today
                </button>

            </div>
        </div>
    );


    const CalendarStartContainer = ({ children }) => (
        <div style={{ zIndex: '99px', backgroundColor: 'white', border: '1px solid lightgray' }}>
            {children}
            <div style={{ justifyContent: 'center', padding: '10px', borderTop: '1px solid #ddd', marginLeft: '65px' }}>
                <button type="button" className='today-btn' onClick={() => handleTodayClick("start")}>
                    Today
                </button>

            </div>
        </div>
    );



    const isValidDate = (dateString) => {
        const regEx = /^\d{4}-\d{2}-\d{2}$/;
        return dateString.match(regEx) !== null;
    };

    // Function to format dates as "yyyy-MM-dd"
    const formatDate = (dateString) => {
        const [year, month, day] = dateString.split('-');
        const formattedMonth = month.padStart(2, '0');
        const formattedDay = day.padStart(2, '0');
        return `${year}-${formattedMonth}-${formattedDay}`;
    };



    const handleHideCheckboxChange = () => {
        setIsHideChecked(!isHideChecked);

        if (isHideChecked) {
            // Reset to original dates
            setStartDate(formatCurDate);
            setEndDate(formatCurDate);
        } else {
            // Set FROM date to 1/1/2015 and TO date to the current date
            setStartDate('1/1/2015');
            setEndDate(formatCurDate);
        }
    };




    // Api Integration of all Dropdowns

    useEffect(() => {


        const storedSelectedStatusRadioButton = localStorage.getItem('selectedStatusRadioButton');
        if (storedSelectedStatusRadioButton) {
            setSelectedStatusRadioButton(storedSelectedStatusRadioButton);
        }

        // Load stored userData from localStorage on component mount
        const storedUserData = localStorage.getItem('userData');
        var inputStruct = {

            LoggedInUserDetails: userData

        }
        console.log('LoginUserData', userData);
        var myInput = { sInputJSON: JSON.stringify(userData) };

        console.log("input of" + ClaimStatusConstants.GetClaimDropDowns, myInput);
        myInput = JSON.stringify(myInput);

        const response = fetch(APIConstants.BASE_URL + ClaimApprovalConstants.GetClaimDropDowns, {
            method: 'POST',
            headers: {

                'Accept': 'application/json',
                'Content-Type': 'application/json'

            },

            body: myInput
        })


            .then((response) => response.json())
            .then((data) => {
                // Extract the relevant data from the response
                const parsedData = JSON.parse(data.d);
                const dropdownData = parsedData.Data;


                console.log("dropdownData", dropdownData);
                setSelectAllDropdown(dropdownData);
                // Populate the dropdowns with the received data
                setLocations(dropdownData.LocationDetails)

                setCMS33aData(dropdownData.CMSbox33aData);
                setCMS33bData(dropdownData.CMSbox33bData);
                setBillingNPIs(dropdownData.PracticeBillingNPIs);
                setServiceLocations(dropdownData.ServiceLocation);
                setPracticeProvider(dropdownData.PracticeProviders);
                setProviderCategory(dropdownData.ProvidersCategories);
                setSearchFilterData(dropdownData.SearchByFilters);
                setStatusRadioButton(dropdownData.StatusRadioButtons);
                setCheckedRadioButton(dropdownData.CheckedInRadioButtons);
                setLoading(false);


            })

            .catch((error) => {
                console.error('Error fetching data: ', error);
            });

    }, [userData])




    //Fetch the All claim status services

    useEffect(() => {


        var inputStruct = {

            sPracticeID: userPracticeID

        }

        var myInput = { sInputJSON: JSON.stringify(inputStruct) };

        console.log("input of GetService " + ClaimStatusConstants.GetClaimServices, myInput);
        var myInputData = JSON.stringify(myInput);

        const response = fetch(APIConstants.BASE_URL + ClaimStatusConstants.GetClaimServices, {
            method: 'POST',
            headers: {

                'Accept': 'application/json',
                'Content-Type': 'application/json'

            },

            body: myInputData
        })


            .then((response) => response.json())
            .then((data) => {

                const parsedData = JSON.parse(data.d);
                const serviceData = parsedData.Data;
                setClaimServices(parsedData)

                console.log("ClaimServiceData", claimservices);
            })

            .catch((error) => {
                console.error('Error fetching data: ', error);
            });

    }, [])


    //Fetch the data of Practice Billing NPIs
    useEffect(() => {


        var inputStruct = {

            LoggedInUserDetails: userData
        }

        var myInput = { sInputJSON: JSON.stringify(inputStruct) };

        console.log("input of GetService " + ClaimStatusConstants.GetTransactionCode, myInput);
        var myInputData = JSON.stringify(myInput);

        const response = fetch(APIConstants.BASE_URL + ClaimStatusConstants.GetPracticeBillingNPIs, {
            method: 'POST',
            headers: {

                'Accept': 'application/json',
                'Content-Type': 'application/json'

            },

            body: myInputData
        })


            .then((response) => response.json())
            .then((data) => {

                const parsedData = JSON.parse(data.d);
                const practiceData = parsedData.Data;

                setPracticeBillingNPIs(practiceData)

                console.log("practiceBillingNPIs", practiceBillingNPIs);
            })

            .catch((error) => {
                console.error('Error fetching data: ', error);
            });

    }, [])













    const handleLocationChange = (e, item) => {
        const newSelectedLocation = e.target.value;
        setSelectedLocation(newSelectedLocation || (item.LocationId));
        setSelectLocationID(newSelectedLocation || (item.LocationId));
        console.log("LocationID", selectLocationID);

        localStorage.setItem('selectedLocation', newSelectedLocation);
    };





    const handleRadioButtonsChange = (e) => {

        setSelectedStatusRadioButton(e.target.value);
        localStorage.setItem('selectedStatusRadioButton', e.target.value);
        const selectedValue = e.target.value;
        setsClaimStatus(selectedValue);


        console.log("claim", sClaimStatus);

    }






    useEffect(() => {

        setsClaimStatus(selectedStatusRadioButton);
        handleTableDataClick();
        console.log("claim", sClaimStatus);
    }, [selectedStatusRadioButton, sClaimStatus]);






    const fetchPatientNames = () => {


        var inputJSON = {
            PracticeID: userPracticeID,
            SearchKey: searchText,
            SearchBy: 0,
            isFromLogin: 0
        }

        var sJSONInput = JSON.stringify(inputJSON);
        console.log("input of" + CommonAPIConstants.GetAllPatientNames, inputJSON);

        const url = `${APIConstants.BASE_URL_SEARCH}${CommonAPIConstants.GetAllPatientNames}?sJSONInput=${sJSONInput}`;

        console.log("URL: ", url);

        fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        })

            .then((response) => {
                if (response.status != 200) { console.log("response.status", response.status); }
                else return response.json();
            })
            .then(data => {



                const parsedData = JSON.parse(data);

                const patientData = parsedData.Data



                console.log("patientLists of" + CommonAPIConstants.GetAllPatientNames, patientData);

                if (Array.isArray(patientData)) {
                    setSuggestions
                        (patientData.map((item) => ({
                            label: `${item.LastName}, ${item.FirstName}`,
                            val: item.PatientID,
                        })));

                } else {


                    setSuggestions([]);

                    setIsTextBoxDisabled(false);
                }
                console.log("PatientsuggestionsLists", suggestions);

            })
            .catch((error) => {
                console.error('Error fetching patient names:', error);
            });
    };









    const fetchUpdatedBy = () => {

        var inputStruct = {


            "sPracticeID": userPracticeID,
            "sUserID": userId,
            "srchKey": searchText


        }

        console.log('userData', userData);
        var myInput = { sInputJSON: JSON.stringify(inputStruct) };

        var myInputData = JSON.stringify(myInput);
        console.log("input of" + ClaimApprovalConstants.GetSuggestionDropDowns, myInputData);

        const response = fetch(APIConstants.BASE_URL + ClaimApprovalConstants.GetSuggestionDropDowns, {
            method: 'POST',
            headers: {

                'Accept': 'application/json',
                'Content-Type': 'application/json'

            },

            body: myInputData
        })

            .then((response) => response.json())
            .then((data) => {
                // Extract the relevant data from the response

                const parsedData = JSON.parse(data.d);

                const suggestionData = parsedData.Data

                console.log("updatedLists of " + ClaimApprovalConstants.GetSuggestionDropDowns, suggestionData);


                if (suggestionData.length > 0) {
                    setSuggestions(suggestionData.map((item) => ({
                        label: item.split('$')[1],
                        val: item.split('$')[0]
                    })));


                    const defaultSuggestion = suggestionData.find((item) => item === defaultUpdatedBy);
                    if (defaultSuggestion) {
                        setSearchText({
                            label: defaultSuggestion.split('$')[1],
                            val: defaultSuggestion.split('$')[0],
                        });
                    }
                } else {
                    setSuggestions([]);
                    setIsTextBoxDisabled(false);
                }
                console.log("Suggestions of " + ClaimApprovalConstants.GetSuggestionDropDowns, suggestions);

            })
            .catch((error) => {
                console.error('Error fetching provider names:', error);

            });



    };




    const fetchSubmittedBy = () => {

        var inputStruct = {


            "sPracticeID": userPracticeID,
            "sUserID": userId,
            "srchKey": searchText


        }

        console.log('userData', userData);
        var myInput = { sInputJSON: JSON.stringify(inputStruct) };

        var myInputData = JSON.stringify(myInput);
        console.log("input of" + ClaimApprovalConstants.GetSuggestionDropDowns, myInputData);

        const response = fetch(APIConstants.BASE_URL + ClaimApprovalConstants.GetSuggestionDropDowns, {
            method: 'POST',
            headers: {

                'Accept': 'application/json',
                'Content-Type': 'application/json'

            },

            body: myInputData
        })

            .then((response) => response.json())
            .then((data) => {
                // Extract the relevant data from the response

                const parsedData = JSON.parse(data.d);

                const suggestionData = parsedData.Data

                console.log("Submitted data of " + ClaimApprovalConstants.GetSuggestionDropDowns, suggestionData);


                if (suggestionData.length > 0) {
                    setSuggestions(suggestionData.map((item) => ({
                        label: item.split('$')[1],
                        val: item.split('$')[0]
                    })));
                } else {
                    setSuggestions([]);
                    setIsTextBoxDisabled(false);
                }



            })
            .catch((error) => {
                console.error('Error fetching provider names:', error);

            });



    };





    const fetchSearchProviders = () => {

        // if (!searchProvidersText) {
        //     //If searchText is empty, you may want to reset or clear any existing data
        //     setSearchPatientData([]);
        //     setIsSuggestionBoxDisabled(true);// Disable suggestion box if needed
        //     return;
        // }



        var inputStruct = {

            "sProviderName": searchText,
            "sPracticeID": userPracticeID,
            "LoggedInUserDetails": userData

        }

        console.log('userData', userData);
        var myInput = { sInputJSON: JSON.stringify(inputStruct) };

        var myInputData = JSON.stringify(myInput);
        console.log("input of" + IntelliBillConstants.GetIntelliProvidersNames, myInputData);

        const response = fetch(APIConstants.BASE_URL + IntelliBillConstants.GetIntelliProvidersNames, {
            method: 'POST',
            headers: {

                'Accept': 'application/json',
                'Content-Type': 'application/json'

            },

            body: myInputData
        })

            .then((response) => response.json())
            .then((data) => {
                // Extract the relevant data from the response

                const parsedData = JSON.parse(data.d);

                const providersData = parsedData.Data

                console.log("providersLists of " + IntelliBillConstants.GetIntelliProvidersNames, providersData);


                if (Array.isArray(providersData)) {
                    setSuggestions(providersData.map((item) => ({
                        label: (item.split('$')[0]).split('|')[1].trim(),
                        val: item.split('$')[1].trim(),
                    })));
                } else {
                    setSuggestions([]);
                }



            })
            .catch((error) => {
                console.error('Error fetching provider names:', error);

            });
    };







    const fetchInsuranceCompanies = () => {



        var inputJSON = {

            SearchKey: searchText,

        }

        var sJSONInput = JSON.stringify(inputJSON);
        console.log("input of" + CommonAPIConstants.GetInsuCompanyNames, inputJSON);

        const url = `${APIConstants.BASE_URL_SEARCH}${CommonAPIConstants.GetInsuCompanyNames}?sJSONInput=${sJSONInput}`;

        console.log("URL: ", url);

        fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        })

            .then((response) => {
                if (response.status != 200) { console.log("response.status", response.status); }
                else return response.json();
            })
            .then(data => {


                const parsedData = JSON.parse(data);

                const InsuranceData = parsedData.Data

                console.log("InsuranceLists of" + CommonAPIConstants.GetInsuCompanyNames, InsuranceData);




                if (Array.isArray(InsuranceData)) {

                    const filteredSuggestions = InsuranceData

                        .map(item => ({
                            label: item.Insurance,
                            val: item.InsuID,
                        }))



                    const filteredData = filteredSuggestions.filter(ins =>
                        ins.label.toLowerCase().includes(searchText.toLowerCase())
                    );


                    setSuggestions(filteredData);

                } else {
                    setSuggestions([]);
                    setIsTextBoxDisabled(false);
                }


                console.log("suggestionsLists", suggestions);
                setIsTextBoxDisabled(false);
            })

            .catch((error) => {
                console.error('Error fetching Insurance names:', error);
                setSuggestions([]);

            });

        return [];

    };






    // const isInsMounted = useRef(true);


    // useEffect(() => {
    //     if (isInsMounted.current) {
    //         isInsMounted.current = false;
    //         setSuggestions([]);
    //     } else if (selectedSearchFilter === 'Insurance' && searchText) {
    //         fetchInsuranceCompanies();
    //     }
    // }, [searchText, selectedSearchFilter]);












    //Fetch CPT List


    const fetchCPTList = () => {

        if (!selectedCptValue) {
            // If searchText is empty, you may want to reset or clear any existing data
            setCptValueList([]);
            setIsSuggestionBoxDisabled(true); // Disable suggestion box if needed
            return; // Skip API call
        }



        var inputStruct =
        {
            cptCode: selectedCptValue
        }

        console.log('userData', userData);
        var myInput = { sInputJSON: JSON.stringify(inputStruct) };

        var myInputData = JSON.stringify(myInput);
        console.log("input of" + CommonAPIConstants.GetCPTList, myInputData);


        const response = fetch(APIConstants.BASE_URL + CommonAPIConstants.GetCPTList, {
            method: 'POST',

            headers: {

                'Accept': 'application/json',
                'Content-Type': 'application/json'

            },

            body: myInputData
        })

            .then((response) => response.json())
            .then((data) => {

                const parsedData = JSON.parse(data.d);

                const cptData = parsedData.Data

                const filteredCPTData = cptData.filter(item =>
                    `${item.CPT_Code}` !== selectedCptValue
                );

                setCptValueList(filteredCPTData);

                console.log("CPTLists of " + CommonAPIConstants.GetCPTList, cptValueList);
            })
            .catch((error) => {
                console.error('Error fetching CPT names:', error);

            });
    };






    useEffect(() => {

        fetchCPTList(selectedCptValue);
    }, [selectedCptValue]);

    const handleCPTList = (suggestion) => {
        setSelectedCptValue(`${suggestion.CPT_Code}`);
        setSelectedCPTCode(`${suggestion.CPT_Code}`);
        setCptValueList([]);
        //  setSelectedUnitValue(1);
        const billingFee = parseFloat(suggestion.Billing_Fee).toFixed(2);
        //  setSelectedUnitChargeValue(billingFee);

        console.log('Selected suggestion:', billingFee);
    };


    const handleCPTKeyDown = (e) => {
        if (e.key === 'Backspace') {
            // Handle backspace key
            if (selectedCptValue === '' && cptValueList.length > 0) {
                // If input is empty and there are suggestions, remove the entire list
                setCptValueList([]);


            } else {
                // If input is not empty, dynamically filter suggestions based on the current input
                fetchCPTList(selectedCptValue.slice(0, -1)) // Remove the last character from searchText

            }
        }
    }


    const handleSelectBillingNPI = (event) => {
        const selectedValue = event.target.value;
        setSelectedBillingNPI(selectedValue);

    }


    // const filteredProviders = practiceProvider.filter(provider => provider.Supervisor === '1' || provider.Supervisor === '3');

    const handleSelectFilterProviders = (event) => {
        const selectedValue = event.target.value;
        setSelectedFilterProvider(selectedValue);

    }



    const [selectedProvider, setSelectedProvider] = useState('');
    const [tdata, setTdata] = useState('');





    // Function to handle checkbox change
    const handleCheckboxChange = (e) => {
        const value = e.target.checked ? 1 : 0; // Set 1 if checked, 0 if unchecked
        setIsChecked(value);
    };




    useEffect(() => {

        setSelectedCheckedRadioButton('0');
        setSelectedStatusRadioButton('0');
    }, []);

    const handleRadioChange = (e) => {
        setSelectedCheckedRadioButton(e.target.value);
    };



    const processTableData = () => {
        tableDetails.forEach((item) => {

            setRowsValidation(item.DataValidationMessage);
        });
    };


    useEffect(() => {
        setTotalRecords(filteredTableDetails?.length);

        if (selectedRecValue === 'all') {
            setDisplayedRecords(filteredTableDetails);
        } else {
            setDisplayedRecords(filteredTableDetails.slice(0, selectedRecValue));
        }
    }, [filteredTableDetails, selectedRecValue]);


    const handleSelectChange = (e) => {
        const value = e.target.value;
        setSelectedRecValue(value);
    };





    //Get all total Records of Main Table

    useEffect(() => {
        const parseAmount = (amount) => {
            if (typeof amount === 'string') {
                const cleanedAmount = amount.replace(/\$/g, '').trim();
                return cleanedAmount ? parseFloat(cleanedAmount) : 0;
            }
            if (typeof amount === 'number') {
                return amount;
            }
            return 0;
        };

        // Reset totals to zero before calculating new amounts
        setTotals({
            totalUnits: 0,
            totalSubmitted: 0,
            totalReceived: 0,
            totalWriteOff: 0,
            totalAdminWriteOff: 0,
            totalAdjustmentAmt: 0,
            totalSecPendingAmt: 0,
            totalBalance: 0,
            totalSecReceived: 0,
            totalDeductible: 0,
            totalPatientRes: 0
        });

        // Loop through displayedRecords to calculate new totals
        displayedRecords?.forEach((claim) => {
            const curRowunits = claim['Units']?.trim();
            const curRowCharges = claim['totalcharge'];
            const totalReceived = claim['recvdCharge'];
            const curRowWriteOff = claim['WriteOffAmount'];
            const curRowBalance = claim['claimbln'];
            const AdminWriteOff = claim['AdminWriteOff'];
            const totalDeductible = claim['Deductible'];
            const totalSecReceived = claim['SecrecvdCharge'];
            const totalPatientRes = claim['PatientAmount'];
            const AdjustmentAmt = claim['Adjustment'];
            const SecPendingAmt = claim['SecPendingAmt'];




            if (curRowunits !== undefined && curRowunits !== '')
                setTotals((prevTotals) => ({ ...prevTotals, totalUnits: prevTotals.totalUnits + parseInt(curRowunits) }));

            if (curRowCharges !== undefined && curRowCharges !== '')
                setTotals((prevTotals) => ({ ...prevTotals, totalSubmitted: prevTotals.totalSubmitted + parseAmount(curRowCharges) }));

            if (totalReceived !== undefined && totalReceived !== '')
                setTotals((prevTotals) => ({ ...prevTotals, totalReceived: prevTotals.totalReceived + parseAmount(totalReceived) }));

            if (totalSecReceived !== undefined && totalSecReceived !== '')
                setTotals((prevTotals) => ({ ...prevTotals, totalSecReceived: prevTotals.totalSecReceived + parseAmount(totalSecReceived) }));

            if (AdjustmentAmt !== undefined && AdjustmentAmt !== '')
                setTotals((prevTotals) => ({ ...prevTotals, totalAdjustmentAmt: prevTotals.totalAdjustmentAmt + parseAmount(AdjustmentAmt) }));

            if (SecPendingAmt !== undefined && SecPendingAmt !== '')
                setTotals((prevTotals) => ({ ...prevTotals, totalSecPendingAmt: prevTotals.totalSecPendingAmt + parseAmount(SecPendingAmt) }));

            if (totalDeductible !== undefined && totalDeductible !== '')
                setTotals((prevTotals) => ({ ...prevTotals, totalDeductible: prevTotals.totalDeductible + parseAmount(totalDeductible) }));

            if (totalPatientRes !== undefined && totalPatientRes !== '')
                setTotals((prevTotals) => ({ ...prevTotals, totalPatientRes: prevTotals.totalPatientRes + parseAmount(totalPatientRes) }));

            if (curRowWriteOff !== undefined && curRowWriteOff !== '')
                setTotals((prevTotals) => ({ ...prevTotals, totalWriteOff: prevTotals.totalWriteOff + parseAmount(curRowWriteOff) }));

            if (AdminWriteOff !== undefined && AdminWriteOff !== '')
                setTotals((prevTotals) => ({ ...prevTotals, totalAdminWriteOff: prevTotals.totalAdminWriteOff + parseAmount(AdminWriteOff) }));

            if (curRowBalance !== undefined && curRowBalance !== '')
                setTotals((prevTotals) => ({ ...prevTotals, totalBalance: prevTotals.totalBalance + parseAmount(curRowBalance) }));


        });
    }, [displayedRecords]);





    useEffect(() => {
        const parseAmount = (amount) => {
            if (typeof amount === 'string') {
                const cleanedAmount = amount.replace(/\$/g, '').trim();
                return cleanedAmount ? parseFloat(cleanedAmount) : 0;
            }
            if (typeof amount === 'number') {
                return amount;
            }
            return 0;
        };

        // Reset totals to zero before calculating new amounts
        setTotalsClaims({
            totalSubmitClaim: 0,
            totalNonSubmitted: 0,
            totalSent: 0,
            totalForwarded: 0,
            totalReceivedClaim: 0,
            totalPosted: 0,
            totalPaid: 0,
            totalRejected: 0,
            totalDenied: 0
        });

        // Loop through claimRecCountsTableData to calculate new totals
        claimRecCountsTableData?.forEach((claim) => {
            const totalSubmitClaim = claim['Submitted']?.trim();
            const totalNonSubmitted = claim['NonSubmitted'];
            const totalSent = claim['SENT'];
            const totalForwarded = claim['FORWARDED'];
            const totalReceivedClaim = claim['PaymentReceived'];
            const totalPosted = claim['PaymentPosted'];
            const totalPaid = claim['PAID'];
            const totalRejected = claim['REJECTED'];
            const totalDenied = claim['DENIED'];




            if (totalSubmitClaim !== undefined && totalSubmitClaim !== '')
                setTotalsClaims((prevTotals) => ({ ...prevTotals, totalSubmitClaim: prevTotals.totalSubmitClaim + parseInt(totalSubmitClaim) }));

            if (totalNonSubmitted !== undefined && totalNonSubmitted !== '')
                setTotalsClaims((prevTotals) => ({ ...prevTotals, totalNonSubmitted: prevTotals.totalNonSubmitted + parseAmount(totalNonSubmitted) }));

            if (totalSent !== undefined && totalSent !== '')
                setTotalsClaims((prevTotals) => ({ ...prevTotals, totalSent: prevTotals.totalSent + parseAmount(totalSent) }));

            if (totalForwarded !== undefined && totalForwarded !== '')
                setTotalsClaims((prevTotals) => ({ ...prevTotals, totalForwarded: prevTotals.totalForwarded + parseAmount(totalForwarded) }));

            if (totalReceivedClaim !== undefined && totalReceivedClaim !== '')
                setTotalsClaims((prevTotals) => ({ ...prevTotals, totalReceivedClaim: prevTotals.totalReceivedClaim + parseAmount(totalReceivedClaim) }));

            if (totalPosted !== undefined && totalPosted !== '')
                setTotalsClaims((prevTotals) => ({ ...prevTotals, totalPosted: prevTotals.totalPosted + parseAmount(totalPosted) }));

            if (totalPaid !== undefined && totalPaid !== '')
                setTotalsClaims((prevTotals) => ({ ...prevTotals, totalPaid: prevTotals.totalPaid + parseAmount(totalPaid) }));

            if (totalRejected !== undefined && totalRejected !== '')
                setTotalsClaims((prevTotals) => ({ ...prevTotals, totalRejected: prevTotals.totalRejected + parseAmount(totalRejected) }));


            if (totalDenied !== undefined && totalDenied !== '')
                setTotalsClaims((prevTotals) => ({ ...prevTotals, totalDenied: prevTotals.totalDenied + parseAmount(totalDenied) }));


        });

        // ReloadClaimsData('all')
    }, [claimRecCountsTableData]);



    // Fetch all Transaction Codes

    useEffect(() => {


        var inputStruct = {


        }

        var myInput = { sInputJSON: JSON.stringify(inputStruct) };

        console.log("input of Transaction " + ClaimStatusConstants.GetTransactionCode, myInput);
        var myInputData = JSON.stringify(myInput);

        const response = fetch(APIConstants.BASE_URL + ClaimStatusConstants.GetTransactionCode, {
            method: 'POST',
            headers: {

                'Accept': 'application/json',
                'Content-Type': 'application/json'

            },

            body: myInputData
        })


            .then((response) => response.json())
            .then((data) => {

                const parsedData = JSON.parse(data.d);


                setTransactionCodes(parsedData)

                console.log("transactionCodes", transactionCodes);
            })

            .catch((error) => {
                console.error('Error fetching data: ', error);
            });

    }, [])




    //Filtered the data based on Checkboxes in MainTable


    useEffect(() => {
        let filteredClaimsList = [];

        if (isClaimChecked) {
            var allClaims = [...tableDetails];
            filteredClaimsList = filteredClaimsList.concat(allClaims);
            console.log("filteredClaimsList", filteredClaimsList);

        } else {
            if (isNonSubmitChecked) {
                const nonSubClaims = tableDetails.filter((claims) => claims.SubmitDate === '');
                filteredClaimsList = filteredClaimsList.concat(nonSubClaims);
            }

            if (isSubmitChecked) {
                const submittedClaims = tableDetails.filter((claims) => claims.SubmitDate !== '');
                filteredClaimsList = filteredClaimsList.concat(submittedClaims);
            }

            if (isSentChecked) {
                const sentClaims = tableDetails.filter((claims) => claims.ClaimStatusInt === 3);
                filteredClaimsList = filteredClaimsList.concat(sentClaims);
            }

            if (isForwardChecked) {
                const fwdClaims = tableDetails.filter((claims) => claims.ClaimStatusInt === 5);
                filteredClaimsList = filteredClaimsList.concat(fwdClaims);
            }


            if (isRecvdChecked) {
                const paymentRecvdClaims = tableDetails.filter((claims) => claims.isPaymentReceived);
                filteredClaimsList = filteredClaimsList.concat(paymentRecvdClaims);
            }

            if (isPaidChecked) {
                const paidClaims = tableDetails.filter((claims) => claims.ClaimStatusInt == 1);
                filteredClaimsList = filteredClaimsList.concat(paidClaims);
            }

            if (isRejectedChecked) {
                const rejectedClaims = displayedRecords.filter((claims) => claims.ClaimStatusInt == 2);
                filteredClaimsList = filteredClaimsList.concat(rejectedClaims);
            }

            if (isDeniedChecked) {
                const deniedClaims = displayedRecords.filter((claims) => claims.isDenied == 1);
                filteredClaimsList = filteredClaimsList.concat(deniedClaims);
            }



        }

        setDisplayedRecords(filteredClaimsList);
    }, [isClaimChecked, isNonSubmitChecked, isSubmitChecked, isSentChecked, isForwardChecked, isRecvdChecked, isPaidChecked,
        isRejectedChecked, isDeniedChecked]);











    const handleInputKeyPress = (event) => {
        if (event.key === 'Backspace') {
            // Handle backspace key
            if (searchText === '' && suggestions.length > 0) {
                setSuggestions([]);
            } else {
                //  Remove the last character from searchText
                const updatedSearchText = searchText.slice(0, -1);

                if (selectedSearchFilter === 'pat') {
                    fetchPatientNames(updatedSearchText);
                } else if (selectedSearchFilter === 'updatedby') {
                    fetchUpdatedBy(updatedSearchText);
                } else if (selectedSearchFilter === 'ins') {
                    fetchInsuranceCompanies(updatedSearchText);
                } else if (selectedSearchFilter === 'submittedby') {
                    fetchSubmittedBy(updatedSearchText);
                } else if (selectedSearchFilter === 'renderingprovider') {
                    fetchSearchProviders(updatedSearchText);
                }

            }
        }
    }








    useEffect(() => {
        // Set the default last 7 days' date range
        const today = new Date();
        const sevenDaysAgo = new Date(today);
        sevenDaysAgo.setDate(today.getDate() - 7);

        setStartDate(sevenDaysAgo);
        setEndDate(today);

        setSearchText(userData.userFullName)
        setSPatID(userData.userID)
        setSInsID(userData.userID)
        setisPageLoad(1)



    }, []);



    //Bind the approval table details



    const handleTableDataClick = (DataValidationMessage, selectedServiceIDs) => {


        setLoading(true);


        setSelectedAdminWriteRows([]);
        setSelectedPolicyRows([]);
        setSelectedWriteOffRows([]);
        setSelectedResubmitRows([]);

        setIsClaimChecked(true);
        setIsSubmitChecked(true);
        setIsNonSubmitChecked(true);
        setIsSentChecked(true);
        setIsForwardChecked(true);
        setIsRecvdChecked(true);
        setIsPostedChecked(true);
        setIsPaidChecked(true);
        setIsRejectedChecked(true);
        setIsDeniedChecked(true);



        let claimArray = []


        var LoggedInUserDetails = {
            PracticeID: userPracticeID
        }

        selectedItem.ClaimID.split(",")?.forEach((id) => {
            claimArray.push({ sClaimID: id.trim() });
        });

        var sInputJSON = JSON.stringify({ ObjClaims: claimArray, LoggedInUserDetails });


        var InputJSON = JSON.stringify(sInputJSON);



        console.log("Input of " + RemittanceConstants.GetMultipleClaimDetails, InputJSON);

        fetch(APIConstants.BASE_URL_BILLING + RemittanceConstants.GetMultipleClaimDetails, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sAuthToken}`
            },
            body: InputJSON,
        })



            .then((response) => {
                if (response.status != 200) { console.log("response.status", response.status); }
                else return response.json();
            })
            .then(data => {



                const parsedData = JSON.parse(data)

                console.log("Response of" + RemittanceConstants.GetMultipleClaimDetails, parsedData);

                setTableDetails(parsedData.Table);
                setadjustmentCodeData(parsedData.Table1)

                setTimeout(() => {
                    setLoading(false);
                    setFilteredTableDetails(parsedData.Table);
                }, 10);

                ;
                setShowServiceErrorModal(false);


            })

            .catch((error) => {
                setError('API request failed');
                setLoading(false);
            })


    }







    const handleDateKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleTableDataClick();
        }
    };




    useEffect(() => {



        if (selectedSearchFilter === '1' && searchText) {
            console.log('searchText', searchText);
            fetchPatientNames();
        } else if (selectedSearchFilter === '9' && searchText) {
            fetchUpdatedBy();
        } else if (selectedSearchFilter === '3' && searchText) {
            fetchInsuranceCompanies();
        }
        else if (selectedSearchFilter === '8' && searchText) {
            fetchSubmittedBy();
        }
        else if (selectedSearchFilter === '5' && searchText) {
            fetchSearchProviders();
        }
        else if (selectedSearchFilter === '4' && searchText) {
            fetchSubmittedBy();
        }

        else if (selectedSearchFilter == 0 && searchText) {
            handleTableDataClick();
        }


    }, [searchText])










    const handleFilterChange = (event) => {





        setIsTextBoxDisabled(selectedSearchFilter === '');


        setSearchText('');



        setSelectedSearchFilter(event.target.value);
        if (selectedSearchFilter !== '7') {
            setBillingNPIs('');
        }

        // Default value for Updated By
        if (event.target.value === "9") {
            setInsOrPatFilter("updatedby");

        } else {
            // Handle other filter changes
            switch (event.target.value) {
                case "1":
                    setInsOrPatFilter("pat");
                    break;
                case "2":
                    setInsOrPatFilter("claimId");
                    break;
                case "3":
                    setInsOrPatFilter("ins");
                    break;
                case "4":
                    setInsOrPatFilter("verifiedby");
                    break;
                case "5":
                    setInsOrPatFilter("renderingprovider");
                    break;
                case "6":
                    setInsOrPatFilter("verifiedbyall");
                    break;
                case "7":
                    setInsOrPatFilter("billingnpi");

                    break;
                case "8":
                    setInsOrPatFilter("submittedby");
                    break;

                case "0":
                    setInsOrPatFilter(" ");
                    break;
                default:

                    break;

            }


        }
    };




    const handleSuggestionSelect = (item) => {
        console.log("Selected item:", item);
        setSearchText(item.label || item.val);

        setSuggestions([]);


        setSPatID(item.val);
        setSInsID(item.val);
        console.log("PatientID", sPatID);



    };



    const hasLoadedInitially = useRef(false);




    useEffect(() => {
        if (!hasLoadedInitially.current) {

            return;
        }


        console.log("Selected Service IDs changed:", selectedServiceIDs);


        if (hasLoadedInitially.current) {
            handleTableDataClick(searchText, selectedServiceIDs);
            hasLoadedInitially.current = false;
        }

        handleClaimServiceChange(selectedServiceIDs)

    }, [selectedServiceIDs]);




    useEffect(() => {
        if (isPageLoad && !hasLoadedInitially.current) {
            console.log("Before triggering handleTableDataClick on page load");
            handleTableDataClick(searchText, selectedServiceIDs);
            console.log("After triggering handleTableDataClick on page load", selectedServiceIDs);
            hasLoadedInitially.current = true; // Mark the initial load as done
        }
    }, [isPageLoad]);
















    const removeHtmlTags = (htmlString) => {
        const tempElement = document.createElement('div');
        tempElement.innerHTML = htmlString;
        return tempElement.textContent || tempElement.innerText;
    };



    const getClassForClaimStatus = (claimStatusFlag) => {
        const cleanClaimStatusFlag = removeHtmlTags(claimStatusFlag);
        switch (cleanClaimStatusFlag) {
            case 'N':
                return 'not-submit-style';
            case 'D':
                return 'denied-style';
            case 'P':
                return 'paid-style';
            case 'F':
                return 'forwarded-style';
            case 'R':
                return 'rejected-style';
            default:
                return '';
        }
    };

    const getTitleForClaimStatus = (claimStatusFlag) => {
        const cleanClaimStatusFlag = removeHtmlTags(claimStatusFlag);
        switch (cleanClaimStatusFlag) {
            case 'N':
                return 'Not-Billed';
            case 'D':
                return 'Denied';
            case 'P':
                return 'Paid';
            case 'F':
                return 'Forwarded';
            case 'R':
                return 'Rejected';
            default:
                return '';
        }
    };





    const convertTimestampToDate = (timestamp) => {
        return new Date(parseInt(timestamp.substr(6)));


    }







    const handleRowCheckboxChange = (index) => {
        if (selectedRows.includes(index)) {
            setSelectedRows(selectedRows.filter((selectedRow) => selectedRow !== index));
        } else {
            setSelectedRows([...selectedRows, index]);
        }
    };

    const handleSelectAllChange = () => {
        const allSelected = tableDetails.every((_, index) => selectedRows.includes(index));

        if (allSelected) {

            setSelectedRows([]);
        } else {

            setSelectedRows(Array.from({ length: tableDetails.length }, (_, index) => index));
        }
    };

    // New function to update "Select All" checkbox state based on individual checkboxes
    const updateSelectAllCheckbox = () => {
        const allSelected = tableDetails.every((_, index) => selectedRows.includes(index));
        const someSelected = selectedRows.length > 0 && !allSelected;

        // Update the "Select All" checkbox based on individual checkboxes
        setSelectAllChecked(allSelected);

    };

    // State for "Select All" checkbox
    const [selectAllChecked, setSelectAllChecked] = useState(false);


    // Use useEffect to update "Select All" checkbox state whenever selectedRows changes
    useEffect(() => {
        updateSelectAllCheckbox();
    }, [selectedRows]);



    useEffect(() => {

        return () => setSelectedPolicyRows([]);
    }, []);


    useEffect(() => {

        setSelectAllChecked(selectedPolicyRows.length > 0);
    }, [selectedPolicyRows]);


    const handlePolicySelectAllChange = () => {
        const allSelected = tableDetails.every((_, index) => selectedPolicyRows.includes(index));
        setSelectedAllChecked((prevChecked) => !prevChecked);

        if (allSelected) {
            // Deselect all 

            setSelectedPolicyRows([]);

        } else {
            // Select all checkboxes
            setSelectedPolicyRows(Array.from({ length: tableDetails.length }, (_, index) => index));
        }


    };



    const handlePolicyRowCheckboxChange = (index) => {

        if (selectedPolicyRows.includes(index)) {
            setSelectedPolicyRows(selectedPolicyRows.filter((selectedRow) => selectedRow !== index));
        } else {
            setSelectedPolicyRows([...selectedPolicyRows, index]);
        }
        setSelectAllChecked(false);
    }



    const handleSecInsuranceCheckboxChange = (index) => {

        if (selectedSecInsuranceRows.includes(index)) {
            setSelectedSecInsuranceRows(selectedSecInsuranceRows.filter((selectedRow) => selectedRow !== index));
        } else {
            setSelectedSecInsuranceRows([...selectedSecInsuranceRows, index]);
        }
        setSelectAllChecked(false);
    }



    useEffect(() => {

        return () => setSelectedWriteOffRows([]);
    }, []);


    useEffect(() => {

        setSelectAllWriteOffChecked(selectedWriteOffRows.length > 0);
    }, [selectedWriteOffRows]);


    const handleWriteOffSelectAllChange = () => {
        const allSelected = tableDetails.every((_, index) => selectedWriteOffRows.includes(index));
        setSelectAllWriteOffChecked((prevChecked) => !prevChecked);

        if (allSelected) {
            // Deselect all checkboxes
            setSelectedWriteOffRows([]);
        } else {
            // Select all checkboxes
            setSelectedWriteOffRows(Array.from({ length: tableDetails.length }, (_, index) => index));
        }


    };



    const handleWriteOffRowCheckboxChange = (index) => {

        if (selectedWriteOffRows.includes(index)) {
            setSelectedWriteOffRows(selectedWriteOffRows.filter((selectedRow) => selectedRow !== index));

        } else {
            setSelectedWriteOffRows([...selectedWriteOffRows, index]);

        }
        setSelectAllWriteOffChecked(false);
    }



    useEffect(() => {

        return () => setSelectedAdminWriteRows([]);
    }, []);

    useEffect(() => {

        setSelectAllAdminWriteChecked(selectedAdminWriteRows.length > 0);
    }, [selectedAdminWriteRows]);





    const handleAdminSelectAllChange = () => {
        const allSelected = tableDetails.every((_, index) => selectedAdminWriteRows.includes(index));
        setSelectAllAdminWriteChecked((prevChecked) => !prevChecked);
        if (allSelected) {
            // Deselect all checkboxes
            setSelectedAdminWriteRows([]);
        } else {
            // Select all checkboxes
            setSelectedAdminWriteRows(Array.from({ length: tableDetails.length }, (_, index) => index));
        }


    };



    const handleAdminRowCheckboxChange = (index) => {

        if (selectedAdminWriteRows.includes(index)) {
            setSelectedAdminWriteRows(selectedAdminWriteRows.filter((selectedRow) => selectedRow !== index));
        } else {
            setSelectedAdminWriteRows([...selectedAdminWriteRows, index]);
        }
        setSelectAllAdminWriteChecked(false);
    }


    useEffect(() => {

        return () => setSelectedResubmitRows([]);
    }, []);



    useEffect(() => {

        setSelectAllResubmit(selectedResubmitRows.length > 0);
    }, [selectedResubmitRows]);


    const handleResubmitAllChange = () => {
        const allSelected = tableDetails.every((_, index) => selectedResubmitRows.includes(index));
        setSelectAllResubmit((prevChecked) => !prevChecked);
        if (allSelected) {
            // Deselect all checkboxes
            setSelectedResubmitRows([]);
        } else {
            // Select all checkboxes
            setSelectedResubmitRows(Array.from({ length: tableDetails.length }, (_, index) => index));
        }


    };



    const handleReSubmitCheckboxChange = (index) => {

        if (selectedResubmitRows.includes(index)) {
            setSelectedResubmitRows(selectedResubmitRows.filter((selectedRow) => selectedRow !== index));
        } else {
            setSelectedResubmitRows([...selectedResubmitRows, index]);
        }
        setSelectAllResubmit(false);
    }






    const handleOpenModal = () => {


        setShowConfirmSaveModal(true);

    };







    const handleCloseModals = () => {
        // Close all modals

        setShowConfirmSaveModal(false);

        setShowVerifiedSaveModal(false);
        setShowSelectErrorModal(false);
        setCloseClaimsModal(false);
        setShowServiceErrorModal(false);
        setShowFaxModal(false);
        setShowDataModal(false)

    };

    const handleOpenDeleteModal = () => {
        if (selectedRows.length === 0) {


            setShowSelectErrorModal(true);
        } else {


            setShowDeleteModal(true);
        }
    };





    const handleDelete = () => {

        const updatedRows = tableDetails.filter((row, index) => !selectedRows.includes(index));

        setTableDetails(updatedRows);
        console.log("deletetablerows", updatedRows);

        setShowDeleteModal(false)
        setDeleteSuccessModal(true)
        setSelectedRows([]);
        setDeleteRowCount(selectedRows.length);
    };







    const formatAppointMentDate = (dateString) => {
        const timestamp = parseInt(dateString.match(/\d+/)[0], 10);
        const date = new Date(timestamp);

        if (isNaN(date.getTime())) {
            return '';
        }
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${month}/${day}/${year}`;
    };








    function getAppLoactionLabelClass(appLocationName) {
        if (appLocationName === 'TP1' || appLocationName === 'TL3') {
            return 'applocation';
        } else if (appLocationName === 'Sec') {
            return 'applocation2';
        } else if (appLocationName === 'NE') {
            return 'applocation3';
        } else {
            return '';
        }


    }



    function getRecievedChargeClass(recievedCharge) {
        if (recievedCharge === 0) {
            return 'nonpaid-claims';
            // } else if (recievedCharge === "") {
            //   return 'paid-claims';
        } else {
            return '';
        }


    }








    const toggleFilters = () => {
        setShowFilters(!showFilters);
    };

    const closeFilters = () => {
        setShowFilters(false);
    };

    const toggleDetails = () => {
        setShowDetails(!showDetails);
    };

    const formatDOSDate = (dateString) => {


        if (!dateString) {
            return ""; // or any default value you want to display for null dates
        }

        const date = new Date(dateString);

        if (isNaN(date.getTime())) {
            return "Invalid Date"; // handle cases where the date string is not valid
        }

        return date.toLocaleDateString("en-US", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit"
        });
    };


    const formatSubmitDate = (dateString) => {
        if (!dateString) {
            return ""; // or any default value you want to display for null dates
        }

        const date = new Date(dateString);

        if (isNaN(date.getTime())) {
            return "Invalid Date"; // handle cases where the date string is not valid
        }

        return date.toLocaleDateString("en-US", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
        });
    };




    //Saved all Claim CPT AdminWriteOffCharges

    const handleSaveClaimCPTAdminWriteOffCharges = async () => {

        console.log("selectedLocations", selectedLocation);
        console.log("selectedLOC", locations);


        console.log("userdata", userData);



        const selectedDataArray = [];

        const updatedRecords = [...displayedRecords];

        for (const rowIndex of selectedAdminWriteRows) {
            const item = updatedRecords[rowIndex];

            item.AdminWriteOff = item.totalcharge;
            const formattedClaimDOS = formatDOSDate(item.ClaimDOS);

            const selectedData = {

                ClaimID: item.ClaimId,
                AdminWriteOffValue: item.AdminWriteOff,
                PracticeID: userPracticeID,
                CPTcode: item.CPTOld,
                DOS: formattedClaimDOS,
                TransactionCode: selectedTransactionCode



            }

            console.log("selectedData", selectedData);

            selectedDataArray.push(selectedData)


        }

        console.log("selectedDataarray", selectedDataArray);
        var inputStruct = {

            SelectedClaims: selectedDataArray,

            LoggedInUserDetails: userData


        };

        var myInput = { sInputJSON: JSON.stringify(inputStruct) };
        console.log("inputRow of" + ClaimStatusConstants.SaveClaimCPTAdminWriteOffCharges, myInput);
        myInput = JSON.stringify(myInput);


        try {


            const response = await fetch(APIConstants.BASE_URL + ClaimStatusConstants.SaveClaimCPTAdminWriteOffCharges, {
                method: 'POST',


                headers: {

                    'Accept': 'application/json',
                    'Content-Type': 'application/json'

                },

                body: myInput
            })


            if (response.ok) {
                const responseData = await response.json();


                const parsedData = JSON.parse(responseData.d);

                setUpdatedTableData(parsedData)

                console.log("SelectedRespData of" + ClaimStatusConstants.SaveClaimCPTAdminWriteOffCharges, responseData);

                console.log("selectedtablerows", selectedRows.length);
                setShowConfirmSaveModal(false)



            } else {
                console.error('Error sending data to the API');
                setSavedRowCount(savedRowCount + selectedRows.length);

            }


            setSelectedRows([]);


        } catch (error) {
            console.error('An error occurred:', error);

        }

    }



    const handleOpenVerifiedModal = (item) => {
        setSelectedVerifiedData('');
        if (item.isVerified) {

            setSavingData(true);
            return;
        }


        console.log("rowdata", item);
        setClaimId(item.ClaimId);
        setCptCode(item.CPTOld);
        const formattedClaimDOS = formatDOSDate(item.ClaimDOS);

        setDos(formattedClaimDOS)

        setShowVerifiedSaveModal(true);
        setSavingData(true);

    }


    //Saved all Verified  data
    const handleSaveVerifiedData = () => {
        setSavingData(false);



        setSelectedVerifiedData('');

        var inputStruct =
        {
            sPracticeID: userPracticeID,
            sClaimID: claimId,
            Comments: selectedVerifiedData,
            DOS: dos,
            CPTCode: cptCode,
            LoggedInUserDetails: userData
        }

        console.log('userData', userData);
        var myInput = { sInputJSON: JSON.stringify(inputStruct) };


        var myInputData = JSON.stringify(myInput)
        console.log("input of" + ClaimStatusConstants.SaveVerifiedData, myInputData);


        const response = fetch(APIConstants.BASE_URL + ClaimStatusConstants.SaveVerifiedData, {
            method: 'POST',

            headers: {

                'Accept': 'application/json',
                'Content-Type': 'application/json'

            },

            body: myInputData
        })

            .then((response) => response.json())
            .then((data) => {

                const parsedData = JSON.parse(data.d);


                setSavingData(true);
                console.log("Data of " + ClaimStatusConstants.SaveVerifiedData, verifiedData);

                const filteredClaims = displayedRecords.filter((claim) => {
                    if (claim.ClaimId == claimId) {
                        claim.isVerified = true;

                    }

                    return true;
                });

                setDisplayedRecords(filteredClaims);
                setShowVerifiedSaveModal(false);


                console.log("filteredata of " + ClaimStatusConstants.SaveVerifiedData, displayedRecords);

            })
            .catch((error) => {
                console.error('An error occurred:', error);

            })



    };


    const verifiedButtonClassName = savingData ? 'saving' : 'btn-style3 mt-2';


    //Get all table data based on totalStatus Records
    const ReloadClaimsData = (filterType, isTotal, claimDOS) => {


        const filteredClaimsData = tableDetails.filter((claim) => {
            console.log('DOS:', claimDOS);
            console.log('isTotal:', isTotal);
            console.log('filterType:', filterType);
            console.log('SubmitDate:', claim.SubmitDate);
            console.log('ClaimStatusInt:', claim["ClaimStatusInt"]);

            const curDOS = formatDOSDate(claim["ClaimDOS"]);
            const submitDate = formatSubmitDate(claim.SubmitDate);
            const recvdCharge = claim.recvdCharge;
            console.log('curDOS:', curDOS);
            console.log('recvdCharge:', recvdCharge);

            //  if (claimDOS !== undefined && (!isTotal && curDOS === claimDOS)) 

            if (!isTotal && curDOS === claimDOS) {
                {
                    switch (filterType) {
                        case 'all':
                            return true;
                        case 'submit':
                            return submitDate !== "";
                        case 'nonsubmit':
                            return submitDate === "";
                        case 'sent':
                            return claim["ClaimStatusInt"] == 3;
                        case 'fwd':
                            return claim["ClaimStatusInt"] == 5;
                        case 'paid':
                            return claim["ClaimStatusInt"] == 1 && claim["isDenied"] == 0 && recvdCharge > 0;
                        case 'rejected':
                            return claim["ClaimStatusInt"] == 2;
                        case 'denied':
                            return claim["isDenied"] === 1;
                        case 'recvd':
                            return claim["isPaymentReceived"];
                        case 'posted':
                            return claim["isPaymentPosted"];
                        default:
                            return false;
                    }
                }
            } else {
                switch (filterType) {
                    case 'all':
                        return true;
                    case 'submit':
                        return submitDate !== "";
                    case 'nonsubmit':
                        return submitDate === "";
                    case 'sent':
                        return claim["ClaimStatusInt"] == 3;
                    case 'fwd':
                        return claim["ClaimStatusInt"] == 5;
                    case 'paid':
                        return claim["ClaimStatusInt"] == 1 && claim["isDenied"] == 0 && recvdCharge > 0;
                    case 'rejected':
                        return claim["ClaimStatusInt"] == 2;
                    case 'denied':
                        return claim["isDenied"] === 1;
                    case 'recvd':
                        return claim["isPaymentReceived"];
                    case 'posted':
                        return claim["isPaymentPosted"];
                    default:
                        return false;
                }
            }
        });

        setDisplayedRecords(filteredClaimsData);
        console.log("filteredClaimsData", filteredClaimsData);
    };




    const debounceRcvdTimeout = useRef(null);


    // Saved the Claim Recieved Charges


    const SaveClaimRecvdCharges = async (inputValue, item, eventName) => {

        console.log("rowData", item);
        console.log("selectedTotalCharge", item.totalcharge);
        // console.log("selectedRecvdCharge", inputValue);


        console.log("userdata", userData);

        if (debounceRcvdTimeout.current) {
            clearTimeout(debounceRcvdTimeout.current);
        }


        debounceRcvdTimeout.current = setTimeout(async () => {
            item.recvdCharge = inputValue === '' ? '' : parseFloat(inputValue);

            if (inputValue !== 'Na' && inputValue !== '') {

                const isClearingInput = inputValue === '';

                if (isClearingInput) {
                    // Handle the case where the user wants to remove all present data
                    setClaimRcvdChargeValue((prevItems) =>
                        prevItems.map((existingItem) =>
                            existingItem === item ? { ...existingItem, recvdCharges: '' } : existingItem
                        )
                    );

                } else {






                    console.log("selectedclaimRecvdChargeValue", claimRecvdChargeValue);

                    const formattedClaimDOS = formatDOSDate(item.ClaimDOS);


                    console.log("item.totalcharge before parsing", item.totalcharge);
                    console.log("inputValue before parsing", inputValue);

                    var totalCharge = parseFloat(item.totalcharge);
                    console.log("TotalCharge after parsing", totalCharge);

                    var recvdCharges = inputValue === '' ? '' : parseFloat(inputValue);
                    console.log("RecvdCharge after parsing", recvdCharges);



                }



            }
            else {
                console.error('inputValue is not a valid number:', inputValue);
                setClaimRcvdChargeValue((prevItems) =>
                    prevItems.map((existingItem) =>
                        existingItem === item ? { ...existingItem, recvdCharges: '' } : existingItem
                    )
                );

                CalculateandShowClaimBalance(item);

            }



            const objClaim = {
                ClaimID: item.ClaimId,
                PracticeID: userPracticeID,
                PatientID: item.PatientID,
                CPT: item.CPTOld,
                PostingCharges: recvdCharges,
                DOS: formatDOSDate(item.ClaimDOS),
                UpdatedBy: userData.userID,
                PriorSec: item.PriorSecClaim
            }




            console.log('userData', userData);
            try {
                if (eventName.type == "blur") {
                    const myInputData = JSON.stringify(JSON.stringify({ 'objClaim': objClaim }));
                    console.log("input of" + PostingpaymentsConstants.CPTReceviedCharge, myInputData);


                    const response = await fetch(APIConstants.BASE_URL_BILLING + PostingpaymentsConstants.CPTReceviedCharge, {
                        method: 'POST',

                        headers: {

                            'Accept': 'application/json',
                            'Content-Type': 'application/json'

                        },

                        body: myInputData
                    })

                    const data = await response.json();
                    console.log("recvdChargeData", data);




                    CalculateandShowClaimBalance(item);
                }


            } catch (error) {
                console.error('An error occurred:', error);
            }
        }, 500);

    }






    const debounceSecRcvdTimeout = useRef(null);

    const SaveSecClaimRecvdCharges = async (inputValue, item, eventName) => {

        console.log("rowData", item);
        console.log("selectedTotalCharge", item.totalcharge);
        // console.log("selectedRecvdCharge", inputValue);



        if (debounceSecRcvdTimeout.current) {
            clearTimeout(debounceSecRcvdTimeout.current);
        }




        debounceSecRcvdTimeout.current = setTimeout(async () => {
            console.log("userdata", userData);

            item.SecrecvdCharge = inputValue === '' ? '' : parseFloat(inputValue);

            if (inputValue !== 'Na' && inputValue !== '') {

                const isClearingInput = inputValue === '';

                if (isClearingInput) {

                    setSecClaimRcvdChargeValue((prevItems) =>
                        prevItems.map((existingItem) =>
                            existingItem === item ? { ...existingItem, SecrecvdCharges: '' } : existingItem
                        )
                    );



                } else {

                    console.log("selectedclaimRecvdChargeValue", claimRecvdChargeValue);

                    const formattedClaimDOS = formatDOSDate(item.ClaimDOS);


                    console.log("item.totalcharge before parsing", item.totalcharge);
                    console.log("inputValue before parsing", inputValue);

                    var totalCharge = parseFloat(item.totalcharge);
                    console.log("TotalCharge after parsing", totalCharge);

                    var recvdCharges = inputValue === '' ? '' : parseFloat(inputValue);
                    console.log("RecvdCharge after parsing", recvdCharges);




                }



            }
            else {
                console.error('inputValue is not a valid number:', inputValue);
                setSecClaimRcvdChargeValue((prevItems) =>
                    prevItems.map((existingItem) =>
                        existingItem === item ? { ...existingItem, SecrecvdCharges: '' } : existingItem
                    )
                );

                CalculateandShowClaimBalance(item);

            }





            const objClaim = {
                ClaimID: item.ClaimId,
                PracticeID: userPracticeID,
                PatientID: item.PatientID,
                CPT: item.CPTOld,
                PostingCharges: recvdCharges,
                DOS: formatDOSDate(item.ClaimDOS),
                UpdatedBy: userData.userID,
                PriorSec: 2
            }




            console.log('userData', userData);


            const myInputData = JSON.stringify(JSON.stringify({ 'objClaim': objClaim }));
            console.log("input of" + PostingpaymentsConstants.CPTReceviedCharge, myInputData);

            try {
                if (eventName.type == "blur") {
                    const response = await fetch(APIConstants.BASE_URL_BILLING + PostingpaymentsConstants.CPTReceviedCharge, {
                        method: 'POST',

                        headers: {

                            'Accept': 'application/json',
                            'Content-Type': 'application/json'

                        },

                        body: myInputData
                    })

                    const data = await response.json();
                    console.log("recvdChargeData", data);
                    var lbltotalCharge = item.totalcharge;
                    var txtRecvdCharge = item.recvdCharge;
                    var txtSecRecvdCharge = item.SecrecvdCharge;





                    CalculateandShowClaimBalance(item);
                }

            } catch (error) {
                console.error('An error occurred:', error);
            }
        }, 500);
    }






    const debounceAdjustTimeout = useRef(null);


    const SaveAdjustMentCharges = async (inputText, item, eventName) => {




        const adjustment = inputText === '' ? '' : parseFloat(inputText);

        // Clear the previous timeout if it exists
        if (debounceAdjustTimeout.current) {
            clearTimeout(debounceAdjustTimeout.current);
        }


        debounceAdjustTimeout.current = setTimeout(async () => {


            const objClaim = {
                ClaimID: item.ClaimId,
                PracticeID: userPracticeID,
                PatientID: item.PatientID,
                CPT: item.CPTOld,
                PostingCharges: inputText,
                DOS: formatDOSDate(item.DOS),
                PriorSec: item.PriorSecClaim,
                UpdatedBy: userData.userID

            }


            console.log('userData', userData);
            const myInput = JSON.stringify(JSON.stringify({ 'objClaim': objClaim }));
            console.log("input of " + CommonAPIConstants.SaveAdjustmentCharges, myInput);

            try {
                if (eventName.type == "blur") {
                    const response = await fetch(APIConstants.BASE_URL_BILLING + CommonAPIConstants.SaveAdjustmentCharges, {
                        method: 'POST',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json'
                        },
                        body: myInput
                    });

                    const data = await response.json();
                    console.log("response", data);


                    if (response.ok) {

                        const updatedItems = adjustmentAmt.map((existingItem) =>
                            existingItem.ClaimId === item.ClaimId
                                ? { ...existingItem, Adjustment: inputText }
                                : existingItem
                        );

                        item.Adjustment = inputText

                        CalculateandShowClaimBalance(item);



                        console.log("Adjustment", item.Adjustment);
                    } else {

                        console.error("API error:", data);
                    }


                }

            } catch (error) {
                console.error('An error occurred:', error);
            }
        }, 500);
    };




    const debounceSecPendingTimeout = useRef(null);


    const SaveSecPendingCharges = async (inputText, item, eventName) => {




        const SecPendingAmt = inputText === '' ? '' : parseFloat(inputText);

        // Clear the previous timeout if it exists
        if (debounceSecPendingTimeout.current) {
            clearTimeout(debounceSecPendingTimeout.current);
        }


        debounceSecPendingTimeout.current = setTimeout(async () => {


            const objClaim = {
                ClaimID: item.ClaimId,
                PracticeID: userPracticeID,
                PatientID: item.PatientID,
                CPT: item.CPTOld,
                PostingCharges: inputText,
                DOS: formatDOSDate(item.DOS),
                PriorSec: item.PriorSecClaim,
                UpdatedBy: userData.userID

            }


            console.log('userData', userData);
            const myInput = JSON.stringify(JSON.stringify({ 'objClaim': objClaim }));
            console.log("input of " + CommonAPIConstants.SaveSecPendingCharges, myInput);

            try {
                if (eventName.type == "blur") {
                    const response = await fetch(APIConstants.BASE_URL_BILLING + CommonAPIConstants.SaveSecPendingCharges, {
                        method: 'POST',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json'
                        },
                        body: myInput
                    });

                    const data = await response.json();
                    console.log("response", data);


                    if (response.ok) {

                        const updatedItems = secPendingAmt.map((existingItem) =>
                            existingItem.ClaimId === item.ClaimId
                                ? { ...existingItem, SecPendingAmt: inputText }
                                : existingItem
                        );

                        item.SecPendingAmt = inputText


                        CalculateandShowClaimBalance(item);


                        console.log("SecPendingAmt", item.SecPendingAmt);
                    } else {

                        console.error("API error:", data);
                    }


                }

            } catch (error) {
                console.error('An error occurred:', error);
            }
        }, 500);
    };






    const SaveClaimdeductibleTemp = (inputText, item, e) => {

        console.log("rowData", item);
        console.log("dDeductible", item.Deductible);

        const updatedItems = Array.isArray(deductibleAmt)
            ? deductibleAmt.map((existingItem) =>
                existingItem.ClaimId === item.ClaimId
                    ? { ...existingItem, dDeductible: inputText }
                    : existingItem
            )
            : [];



        SaveClaimdeductible(inputText, item, e);


    }




    const debounceDeductTimeout = useRef(null);


    const SaveClaimdeductible = async (inputText, item, eventName) => {




        const deductible = inputText === '' ? '' : parseFloat(inputText);

        // Clear the previous timeout if it exists
        if (debounceDeductTimeout.current) {
            clearTimeout(debounceDeductTimeout.current);
        }


        debounceDeductTimeout.current = setTimeout(async () => {


            const objClaim = {
                ClaimID: item.ClaimId,
                PracticeID: userPracticeID,
                PatientID: item.PatientID,
                CPT: item.CPTOld,
                PostingCharges: deductible,
                DOS: formatDOSDate(item.DOS),
                UpdatedBy: userData.userID
            }


            console.log('userData', userData);
            const myInput = JSON.stringify(JSON.stringify({ 'objClaim': objClaim }));
            console.log("input of " + PostingpaymentsConstants.UpdateClaimDeductible, myInput);

            try {
                if (eventName.type == "blur") {
                    const response = await fetch(APIConstants.BASE_URL_BILLING + PostingpaymentsConstants.UpdateClaimDeductible, {
                        method: 'POST',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json'
                        },
                        body: myInput
                    });

                    const data = await response.json();
                    console.log("dPatientAmount", data);


                    if (response.ok) {

                        const updatedItems = deductibleAmt.map((existingItem) =>
                            existingItem.ClaimId === item.ClaimId
                                ? { ...existingItem, dDeductible: deductible }
                                : existingItem
                        );

                        item.Deductible = deductible

                        CalculateandShowClaimBalance(item);



                        console.log("dDeductible", item.Deductible);
                    } else {

                        console.error("API error:", data);
                    }


                }

            } catch (error) {
                console.error('An error occurred:', error);
            }
        }, 500);
    };





    const debounceTimeout = useRef(null);




    const SavePatientResponsibility = async (inputText, item, eventName) => {
        console.log("rowData", eventName);
        console.log("inputText", inputText);
        console.log("selectedTotalCharge", item.PatientAmount);



        // Clear the previous timeout if it exists
        if (debounceTimeout.current) {
            clearTimeout(debounceTimeout.current);
        }


        debounceTimeout.current = setTimeout(async () => {



            const objClaim = {
                ClaimID: item.ClaimId,
                PracticeID: userPracticeID,
                PatientID: item.PatientID,
                CPT: item.CPTOld,
                PostingCharges: inputText,
                DOS: formatDOSDate(item.DOS),
                UpdatedBy: userData.userID

            }

            console.log('userData', userData);
            const myInput = JSON.stringify(JSON.stringify({ 'objClaim': objClaim }));
            console.log("input of " + PostingpaymentsConstants.UpdateClaimPatientResponsibility, myInput);



            try {

                if (eventName.type == "blur") {
                    const response = await fetch(APIConstants.BASE_URL_BILLING + PostingpaymentsConstants.UpdateClaimPatientResponsibility, {
                        method: 'POST',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json'
                        },
                        body: myInput
                    });

                    const data = await response.json();
                    console.log("dPatientAmount", data);

                    if (response.ok) {

                        const updatedItems = patientRes.map((existingItem) =>
                            existingItem.ClaimId === item.ClaimId
                                ? { ...existingItem, dPatientAmount: inputText }
                                : existingItem
                        );

                        item.PatientAmount = inputText
                        CalculateandShowClaimBalance(item);

                    }
                }




            } catch (error) {
                console.error('An error occurred:', error);
            }
        }, 500);


    };




    const SaveClaimWriteOffCharges = async (inputText, item) => {

        console.log("rowData", item);
        console.log("selectedClaimId", item.ClaimId);
        console.log("userdata", userData);

        const updatedItems = claimWriteOffValue.map((existingItem) =>
            existingItem === item
                ? { ...existingItem, WriteOffAmount: inputText }
                : existingItem
        );



        const formattedClaimDOS = formatDOSDate(item.ClaimDOS);
        var totalCharge = item.totalCharge;
        var writeOffAmount = item.WriteOffAmount;
        var swriteOffValue = inputText;

        item.WriteOffAmount = '';


        var totalCharge = parseFloat(item.totalCharge) || 0;
        var recvdCharge = parseFloat(item.recvdCharge) || 0;
        var secRecvdCharge = parseFloat(item.SecrecvdCharge) || 0;
        var deductible = parseFloat(item.Deductible) || 0;
        var patientRes = parseFloat(item.PatientAmount) || 0;
        var writeOffAmount = parseFloat(inputText) || 0;
        var adminWriteOffValue = parseFloat(item.AdminWriteOffValue) || 0;



        const objClaim = {
            ClaimID: item.ClaimId,
            PracticeID: userPracticeID,
            PatientID: item.PatientID,
            CPT: item.CPTOld,
            PostingCharges: swriteOffValue,
            DOS: formatDOSDate(item.ClaimDOS),
            UpdatedBy: userData.userID
        }

        console.log('userData', userData);
        const myInput = JSON.stringify(JSON.stringify({ 'objClaim': objClaim }));


        const response = fetch(APIConstants.BASE_URL_BILLING + PostingpaymentsConstants.UpdateWriteoff, {
            method: 'POST',

            headers: {

                'Accept': 'application/json',
                'Content-Type': 'application/json'

            },

            body: myInput
        })

            .then((response) => response.json())
            .then((data) => {


                //  const parsedData = JSON.parse(response.d);
                console.log("SaveClaimWriteOffData", data);

                if (response.ok) {

                    const updatedItems = claimWriteOffValue.map((existingItem) =>
                        existingItem.ClaimId === item.ClaimId
                            ? { ...existingItem, writeOffAmount: inputText }
                            : existingItem
                    );

                    item.writeOffAmount = inputText
                    CalculateandShowClaimBalance(item);

                }

                CalculateandShowClaimBalance(item);



            })
            .catch((error) => {
                console.error('An error occurred:', error);
            })
    }





    const CalculateandShowClaimBalance = (item) => {
        var lbltotalCharge = item.totalcharge ?? 0;
        var txtRecvdCharge = item.recvdCharge ?? 0;
        var txtAdminWriteoff = item.AdminWriteOff ?? 0;
        var txtWriteoff = item.WriteOffAmount ?? 0;
        var txtSecRecvdCharge = item.SecrecvdCharge ?? 0;
        var txtdeductible = item.Deductible ?? 0;
        var txtPatientRes = item.PatientAmount ?? 0;

        var balance = 0;

        try {
            var totalcharge = lbltotalCharge;
            var recvdcharge = txtRecvdCharge;
            var writeOffValue = txtWriteoff;
            var AdminwriteOffValue = txtAdminWriteoff;
            var secRecvdcharge = txtSecRecvdCharge;
            var deductible = txtdeductible;
            var patientRes = txtPatientRes;
            var adjustmentAmt = item.Adjustment

            console.log("Total totalcharge", totalcharge);
            console.log("Total recvdcharge", recvdcharge);
            console.log("Total writeOffValue", writeOffValue);
            console.log("Total AdminwriteOffValue", AdminwriteOffValue);
            console.log("Total Secrecvdcharge", claimSecRecvdChargeValue);
            console.log("deductible ", deductible);
            console.log("patientRes ", patientRes);


            if (totalcharge == "")
                totalcharge = 0;

            if (recvdcharge == "")
                recvdcharge = 0;

            if (writeOffValue == "")
                writeOffValue = 0;

            if (AdminwriteOffValue == "")
                AdminwriteOffValue = 0;

            if (secRecvdcharge == "")
                secRecvdcharge = 0;

            if (deductible == "")
                deductible = 0;

            if (patientRes == "")
                patientRes = 0;

            if (adjustmentAmt == "")
                adjustmentAmt = 0;




            console.log("balance>>>>>>>", totalcharge, secRecvdcharge, recvdcharge, deductible, patientRes, writeOffValue, adjustmentAmt);


            balance = ((parseFloat(totalcharge)) - (secRecvdcharge + parseFloat(recvdcharge) + parseFloat(deductible) + parseFloat(patientRes)
                + parseFloat(writeOffValue) + parseFloat(adjustmentAmt)));
            console.log("Total Balance???????????????", balance);

            item.claimbln = balance;
        }
        catch (erf) { }
        item.claimbln = balance.toFixed(2);

    }




    const ClosclaimWithCPT = async () => {

        console.log("selectedAdminWriteRows", selectedWriteOffRows);
        console.log("selectedLOC", locations);


        console.log("userdata", userData);

        if (selectedWriteOffRows.length === 0) {
            // Show error modal if no rows are selected

            setShowSelectErrorModal(true);


        } else {



            const selectedDataArray = [];


            for (const rowIndex of selectedWriteOffRows) {
                const item = displayedRecords[rowIndex];


                const formattedClaimDOS = formatDOSDate(item.ClaimDOS);

                const selectedData = {

                    ClaimID: item.ClaimId,
                    PracticeID: userPracticeID,
                    iIsCompClaim: 0,
                    CPTcode: item.CPTOld,
                    DOS: formattedClaimDOS,


                }

                console.log("selectedData", selectedData);

                selectedDataArray.push(selectedData)


            }

            console.log("selectedDataarray", selectedDataArray);
            var inputStruct = {

                JsonDataArr: selectedDataArray,

                LoggedInUserDetails: userData


            };

            var myInput = { sInputJSON: JSON.stringify(inputStruct) };
            console.log("inputRow of" + ClaimStatusConstants.CloseClaimWithCPT, myInput);
            myInput = JSON.stringify(myInput);


            try {


                const response = await fetch(APIConstants.BASE_URL + ClaimStatusConstants.CloseClaimWithCPT, {
                    method: 'POST',


                    headers: {

                        'Accept': 'application/json',
                        'Content-Type': 'application/json'

                    },

                    body: myInput
                })


                if (response.ok) {
                    const responseData = await response.json();


                    const parsedData = JSON.parse(responseData.d);

                    setUpdatedTableData(parsedData)

                    console.log("SelectedRespData of" + ClaimStatusConstants.CloseClaimWithCPT, responseData);

                    setShowSuccessModal(true);



                } else {
                    console.error('Error sending data to the API');


                }



            } catch (error) {
                console.error('An error occurred:', error);

            }

        }
    }






    const debounceChequeTimeout = useRef(null);




    // Saved the Claim CPT Cheque Number


    const SaveClaimCPTChequeNumber = (inputText, item, eventName) => {


        const updatedItems = Array.isArray(cptChequeNumber)
            ? cptChequeNumber.map((existingItem) =>
                existingItem === item
                    ? { ...existingItem, PaymentChqueNo: inputText }
                    : existingItem
            )
            : [];

        setcptChequeNumber(updatedItems);

        item.PaymentChqueNo = inputText;

        // Clear the previous timeout if it exists
        if (debounceChequeTimeout.current) {
            clearTimeout(debounceChequeTimeout.current);
        }


        debounceChequeTimeout.current = setTimeout(async () => {

            const objClaim = {
                ClaimID: item.ClaimId,
                PracticeID: userPracticeID,
                PatientID: item.PatientID,
                CPT: item.CPTOld,
                ChequeNumber: inputText,
                DOS: formatDOSDate(item.ClaimDOS),
                UpdatedBy: userData.userID,
                PriorSec: 1,
                IsLineItemData: 1

            }

            console.log('userData', userData);
            const myInput = JSON.stringify(JSON.stringify({ 'objClaim': objClaim }));

            console.log("Input of " + PostingpaymentsConstants.UpdateCheckNumber, myInput);

            try {

                if (eventName.type == "blur") {
                    const response = await fetch(APIConstants.BASE_URL_BILLING + PostingpaymentsConstants.UpdateCheckNumber, {
                        method: 'POST',

                        headers: {

                            'Accept': 'application/json',
                            'Content-Type': 'application/json'

                        },

                        body: myInput
                    })

                    const data = await response.json();

                    console.log("Data of " + PostingpaymentsConstants.UpdateCheckNumber, data);



                }



            } catch (error) {
                console.error('An error occurred:', error);
            }
        }, 1000);

    };









    const formatDateForInput = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = ('0' + (date.getMonth() + 1)).slice(-2);
        const day = ('0' + date.getDate()).slice(-2);
        return `${year}-${month}-${day}`;
    };






    const formatDateForAPI = (dateString) => {
        if (!dateString) return '';
        const [year, month, day] = dateString.split('-');
        const formattedMonth = (month || '').padStart(2, '0');
        const formattedDay = (day || '').padStart(2, '0');
        return `${formattedMonth}/${formattedDay}/${year}`;
    };





    const UpdateClaimChequeDate = (inputText, item) => {



        let updatedCheckDate = inputText;

        if (isValidDate(inputText)) {
            updatedCheckDate = formatDateForAPI(inputText);
            setCheckDate(updatedCheckDate);
        }

        console.log('updatedCheckDate', updatedCheckDate);


        console.log('checkDate', checkDate);


        item.PaymentChequeDate = updatedCheckDate;

        const objClaim = {
            ClaimID: item.ClaimId,
            PracticeID: userPracticeID,
            PatientID: item.PatientID,
            CPT: item.CPTOld,
            ChequeDate: updatedCheckDate,
            DOS: formatDOSDate(item.ClaimDOS),
            UpdatedBy: userData.userID,
            PriorSec: 1,
            IsLineItemData: 1

        }

        console.log('userData', userData);
        const myInput = JSON.stringify(JSON.stringify({ 'objClaim': objClaim }))
        console.log("Input of " + PostingpaymentsConstants.UpdateCheckDate, myInput);


        const response = fetch(APIConstants.BASE_URL_BILLING + PostingpaymentsConstants.UpdateCheckDate, {
            method: 'POST',

            headers: {

                'Accept': 'application/json',
                'Content-Type': 'application/json'

            },

            body: myInput
        })

            .then((response) => response.json())
            .then((data) => {



                console.log("Data of " + PostingpaymentsConstants.UpdateCheckDate, data);

                const updatedItems = cptChequeDate.map((existingItem) =>
                    existingItem === item
                        ? {
                            ...existingItem,
                            PaymentChequeDate: updatedCheckDate,

                        }
                        : existingItem
                );

                setCptChequeDate(updatedItems);






            })
            .catch((error) => {
                console.error('An error occurred:', error);

            })



    };




    const debounceRefTimeout = useRef(null);

    // Saved the Claim CPT PayerRefID
    const SaveClaimsPayerRefID = (inputText, item, eventName) => {

        item.PayerRefNumber = inputText;

        if (debounceRefTimeout.current) {
            clearTimeout(debounceRefTimeout.current);
        }


        debounceRefTimeout.current = setTimeout(async () => {



            const objClaim = {
                ClaimID: item.ClaimId,
                PracticeID: userPracticeID,

                PayerReferenceNumber: inputText,
                PatientID: item.PatientID,
                DOS: formatDOSDate(item.ClaimDOS),
                UpdatedBy: userData.userID,
                PriorSec: 1,



            }
            console.log('userData', userData);
            const myInput = JSON.stringify(JSON.stringify({ 'objClaim': objClaim }));

            console.log("input of" + PostingpaymentsConstants.UpdateClaimReferencenumber, myInput);

            try {

                if (eventName.type == "blur") {


                    const response = await fetch(APIConstants.BASE_URL_BILLING + PostingpaymentsConstants.UpdateClaimReferencenumber, {
                        method: 'POST',

                        headers: {

                            'Accept': 'application/json',
                            'Content-Type': 'application/json'

                        },

                        body: myInput
                    })

                    const data = await response.json();

                    console.log("Data of " + PostingpaymentsConstants.UpdateClaimReferencenumber, data);


                    const updatedItems = claimPayerRefID.map((existingItem) =>
                        existingItem === item
                            ? {
                                ...existingItem,
                                PayerRefNumber: inputText,

                            }
                            : existingItem
                    );

                    setClaimPayerRefID(updatedItems);

                }

            } catch (error) {
                console.error('An error occurred:', error);
            }

        }, 1000);

    };





    const debounceSecNumTimeout = useRef(null);


    const SecSaveClaimCPTChequeNumber = (inputText, item, eventName) => {

        item.SecCPTChequeNumber = inputText;


        if (debounceSecNumTimeout.current) {
            clearTimeout(debounceSecNumTimeout.current);
        }


        debounceSecNumTimeout.current = setTimeout(async () => {


            const objClaim = {
                ClaimID: item.ClaimId,
                PracticeID: userPracticeID,
                PatientID: item.PatientID,
                CPT: item.CPTOld,
                ChequeNumber: inputText,
                DOS: formatDOSDate(item.ClaimDOS),
                UpdatedBy: userData.userID,
                PriorSec: 2,
                IsLineItemData: 1

            }

            console.log('userData', userData);
            const myInput = JSON.stringify(JSON.stringify({ 'objClaim': objClaim }))
            console.log("Input of " + PostingpaymentsConstants.UpdateCheckNumber, myInput);


            try {

                if (eventName.type == "blur") {
                    const response = await fetch(APIConstants.BASE_URL_BILLING + PostingpaymentsConstants.UpdateCheckNumber, {
                        method: 'POST',

                        headers: {

                            'Accept': 'application/json',
                            'Content-Type': 'application/json'

                        },

                        body: myInput
                    })

                    const data = await response.json();


                    console.log("Data of " + PostingpaymentsConstants.UpdateCheckNumber, data);

                    const updatedItems = cptSecChequeNumber.map((existingItem) =>
                        existingItem === item
                            ? {
                                ...existingItem,
                                SecCPTChequeNumber: inputText,
                                isDataUpdated: true,
                            }
                            : existingItem
                    );

                    setcptsecChequeNumber(updatedItems);




                }

            } catch (error) {
                console.error('An error occurred:', error);
            }

        }, 1000);


    };







    const SecUpdateClaimChequeDate = (inputText, item) => {



        let updatedCheckDate = inputText;

        if (isValidDate(inputText)) {
            updatedCheckDate = formatDateForAPI(inputText);
            setCptSecChequeDate(updatedCheckDate);
        }

        console.log('updatedCheckDate', updatedCheckDate);


        console.log('checkDate', checkDate);


        item.SecCPTChequeDate = updatedCheckDate;

        const objClaim = {
            ClaimID: item.ClaimId,
            PracticeID: userPracticeID,
            PatientID: item.PatientID,
            CPT: item.CPTOld,
            ChequeDate: updatedCheckDate,
            DOS: formatDOSDate(item.ClaimDOS),
            UpdatedBy: userData.userID,
            PriorSec: 2,
            IsLineItemData: 1

        }

        console.log('userData', userData);
        const myInput = JSON.stringify(JSON.stringify({ 'objClaim': objClaim }))
        console.log("Input of " + PostingpaymentsConstants.UpdateCheckDate, myInput);


        const response = fetch(APIConstants.BASE_URL_BILLING + PostingpaymentsConstants.UpdateCheckDate, {
            method: 'POST',

            headers: {

                'Accept': 'application/json',
                'Content-Type': 'application/json'

            },

            body: myInput
        })

            .then((response) => response.json())
            .then((data) => {



                console.log("Data of " + PostingpaymentsConstants.UpdateCheckDate, data);

                const updatedItems = cptSecChequeDate.map((existingItem) =>
                    existingItem === item
                        ? {
                            ...existingItem,
                            PaymentChequeDate: updatedCheckDate,

                        }
                        : existingItem
                );

                setCptSecChequeDate(updatedItems);






            })
            .catch((error) => {
                console.error('An error occurred:', error);

            })



    };





    // Saved the Secondary Claim CPT PayerRefID
    const SecSaveClaimsPayerRefID = (inputText, item) => {

        item.SecPayerclaimRefNumber = inputText;



        const objClaim = {
            ClaimID: item.ClaimId,
            PracticeID: userPracticeID,

            PayerReferenceNumber: inputText,
            PatientID: item.PatientID,
            DOS: formatDOSDate(item.ClaimDOS),
            UpdatedBy: userData.userID,
            PriorSec: 2,


        }
        console.log('userData', userData);
        const myInput = JSON.stringify(JSON.stringify({ 'objClaim': objClaim }));

        console.log("input of" + PostingpaymentsConstants.UpdateClaimReferencenumber, myInput);

        const response = fetch(APIConstants.BASE_URL_BILLING + PostingpaymentsConstants.UpdateClaimReferencenumber, {
            method: 'POST',

            headers: {

                'Accept': 'application/json',
                'Content-Type': 'application/json'

            },

            body: myInput
        })

            .then((response) => response.json())
            .then((data) => {



                console.log("Data of " + PostingpaymentsConstants.UpdateClaimReferencenumber, data);


                const updatedItems = secClaimPayerRefID.map((existingItem) =>
                    existingItem === item
                        ? {
                            ...existingItem,
                            SecPayerclaimRefNumber: inputText,

                        }
                        : existingItem
                );

                setSecClaimPayerRefID(updatedItems);


            })
            .catch((error) => {
                console.error('An error occurred:', error);

            })



    };







    //saved the notes message 

    const UpdateClaimNotes = (inputText, item) => {

        item.ClaimNotes = inputText;

        const objClaim = {
            ClaimID: item.ClaimId,
            PracticeID: userPracticeID,
            PatientID: item.PatientID,
            DOS: formatDOSDate(item.ClaimDOS),
            UpdatedBy: userData.userID,
            ClaimNotes: inputText,
            FirstName: item.FirstName,
            LastName: item.LastName,

        }

        console.log('userData', userData);
        const myInput = JSON.stringify(JSON.stringify({ 'objClaim': objClaim }))
        console.log("Input of " + PostingpaymentsConstants.UpdateClaimNotes, myInput);


        const response = fetch(APIConstants.BASE_URL_BILLING + PostingpaymentsConstants.UpdateClaimNotes, {
            method: 'POST',

            headers: {

                'Accept': 'application/json',
                'Content-Type': 'application/json'

            },

            body: myInput
        })

            .then((response) => response.json())
            .then((data) => {



                console.log("Data of " + PostingpaymentsConstants.UpdateClaimNotes, data);

                setClaimNotes((prevClaimNotes) =>
                    prevClaimNotes.map((existingItem) =>
                        existingItem === item
                            ? {
                                ...existingItem,
                                ClaimNotes: inputText,
                            }
                            : existingItem
                    )
                );



            })
            .catch((error) => {
                console.error('An error occurred:', error);

            })



    };





    //Check Eligiblity






    const handleCheckeligibility = async (e, rowIndex) => {



        console.log("selectedLOC", tableInsDetails.InsurerDOB);
        console.log("Filterprovider", tableInsDetails.InsCountryId);

        console.log("userdata", userData);






        if (selectedPolicyRows.length == 0) {
            setShowSelectErrorModal(true)
            return;
        }


        setRowState((prevState) => ({
            ...prevState,
            [claimID]: { isLoading: true, isHidden: true, showIcon: true }
        }));



        const selectedDataArray = [];

        for (const rowIndex of selectedPolicyRows) {
            const item = filteredTableDetails[rowIndex] || filteredTableDetails[rowIndex];
            setClaimID(item.ClaimId);
            setShowSelectErrorModal(false)

            console.log("Insurance ROW ITEM", item);
            setIsLoading(true);

            const eligibilityDOS = formatDOSDate(item.ClaimDOS);


            var InsCountryId = item.PrimaryIns
            if (InsCountryId == null) {
                InsCountryId = ""
            }

            var PayerID = item.InsPayerID
            if (PayerID == null) {
                PayerID = ""
            }

            console.log("ClaimDOS", item.ClaimDOS);



            var inputStruct = {

                "PatientID": item.PatientID,
                "PracticeID": userPracticeID,
                "PolicyNumber": item.PolicyNumber + "",
                "DOS": eligibilityDOS,
                "RowIndex": rowIndex


            };
        }


        var objPatientDetails = {
            'objPatientDetails': inputStruct
        }
        var myInput = JSON.stringify(objPatientDetails);
        console.log("inputRow of" + CommonAPIConstants.GetPatientEligibility, myInput);


        var myInput = JSON.stringify(objPatientDetails);
        const url = `${APIConstants.PATIENT_PORTAL_URL}${CommonAPIConstants.GetPatientEligibility}?sInputJSON=${myInput}`;

        console.log("URL: ", url);

        fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        })

            .then((response) => {
                if (response.status != 200) { console.log("response.status", response.status); }
                else return response.json();
            })


            .then((data) => {


                const responseData = data
                const parsedData = JSON.parse(responseData);


                setRowState((prevState) => ({
                    ...prevState,
                    [claimID]: { isLoading: false, isHidden: false, showIcon: true },
                }));


                setCheckEligibility(parsedData)


                console.log("SelectedRespData of" + CommonAPIConstants.GetPatientEligibility, checkEligibility);


                var RowIndex = parsedData.RowIndex;
                var InsStatus = parsedData.InsStatus;
                setIsInStatus(parsedData.InsStatus);
                var EligibilityError = parsedData.EligibilityError;




                const payerIDElement = document.querySelector(`.payer${RowIndex}`);


                console.log("Upadated isInStatus :", isInStatus);

                const filteredClaims = filteredTableDetails.filter((item) => {
                    if (item.ClaimId == claimID) {
                        if (payerIDElement) {
                            if (parsedData.InsStatus === "Active") {
                                payerIDElement.style.color = 'green';
                            } else {
                                payerIDElement.style.color = 'red';
                            }
                        }
                    }


                    return true;
                });

                setFilteredTableDetails(filteredClaims);






            }).catch((error) => {
                console.error('An error occurred:', error);

                setRowState((prevState) => ({
                    ...prevState,
                    [claimID]: { isLoading: false, isHidden: false, showIcon: true },
                }));



            })

    }





    const handleSecCheckeligibility = async (e, rowIndex) => {



        console.log("selectedLOC", tableInsDetails.InsurerDOB);
        console.log("Filterprovider", tableInsDetails.InsCountryId);

        console.log("userdata", userData);

        try {



            const selectedDataArray = [];

            for (const rowIndex of selectedSecInsuranceRows) {
                const item = displayedRecords[rowIndex] || displayedRecords[rowIndex];

                // setIsLoading(true);

                const eligibilityDOS = formatDOSDate(item.ClaimDOS);


                var InsCountryId = item.PrimaryInsurance
                if (InsCountryId == null) {
                    InsCountryId = ""
                }

                var PayerID = item.SecPayerID
                if (PayerID == null) {
                    PayerID = ""
                }

                console.log("Dos", item.DOS);



                var inputStruct = {


                    "PayerID": PayerID + "",
                    "sIns_PolicyNumber": item.PolicyNumber + "",
                    "patientID": item.PatientId,
                    "sInsuredFName": item.FirstName,
                    "sInsuredLName": item.LastName,
                    "sInsuredStateName": item.InsuredStateName + "",
                    "sInsuredDOB": formatDOSDate(item.DOB) + "",
                    "sInsCoID": InsCountryId,
                    "EligibilityDOS": eligibilityDOS + "",
                    "EligibilityRowIndex": rowIndex,
                    "LoggedInUserDetails": userData



                };
            }
            var myInput = { sInputJSON: JSON.stringify(inputStruct) };
            console.log("inputRow of" + CommonAPIConstants.CheckPatientEligibility, myInput);
            myInput = JSON.stringify(myInput);


            try {


                const response = await fetch(APIConstants.BASE_URL + CommonAPIConstants.CheckPatientEligibility, {
                    method: 'POST',


                    headers: {

                        'Accept': 'application/json',
                        'Content-Type': 'application/json'

                    },

                    body: myInput
                })


                if (response.ok) {
                    const responseData = await response.json();


                    const parsedData = JSON.parse(responseData.d);

                    setCheckEligibility(parsedData)
                    console.log("SelectedRespData of" + CommonAPIConstants.CheckPatientEligibility, checkEligibility);

                    if (checkEligibility.length > 0) {
                        var RowIndex = checkEligibility[0].RowIndex;
                        var InsStatus = checkEligibility[0].InsStatus;
                        setIsInStatus(InsStatus);
                        var EligibilityError = checkEligibility[0].EligibilityError;
                    }



                    const payerIDElement = document.querySelector(`.payer-id-${RowIndex}`);

                    if (payerIDElement) {
                        if (InsStatus === "Active") {
                            payerIDElement.style.color = 'green';
                        } else {
                            payerIDElement.style.color = 'red';
                        }
                    }




                } else {
                    setCheckEligibility([]);
                    console.error('Error sending data to the API');


                }



            } catch (error) {
                console.error('An error occurred:', error);

            }
        } finally {
            setIsLoading(false);

        }

    }




    const handleInputClick = () => {
        setIsFocused(true);
    };



    const handleRowClick = (index) => {
        setActiveRow(index);
    };



    const getVerifiedBy = (name) => {
        if (!name) {
            return ''; // Return an empty string if 'name' is undefined
        }

        return name
            .split(" ")
            .map((word) => (word[0] ? word[0].toUpperCase() : ''))
            .join("");
    };



    const handleClaimCheckboxChange = () => {
        setIsClaimChecked(!isClaimChecked);

    }






    //Filtered the data based on Status in MainTable


    const handleStatusFilterChange = (statusInt) => {
        setStatusFilter(statusInt);


        const filteredRecords = tableDetails.filter((item) => {
            const cleanClaimStatusFlag = removeHtmlTags(item.ClaimStatusFlag);
            switch (statusInt) {
                case 0:
                    return cleanClaimStatusFlag === 'N';
                case 1:
                    return cleanClaimStatusFlag === 'P';
                case 2:
                    return cleanClaimStatusFlag === 'R';
                case 5:
                    return cleanClaimStatusFlag === 'F';
                case 9:
                    return cleanClaimStatusFlag === 'D';
                default:
                    return false;
            }
        });

        setDisplayedRecords(filteredRecords);
    };


    const isActive = (status) => {
        return prevFilter === status;
    };



    const handleClosedCheckboxChange = () => {
        setIsClaimClosed(prevState => !prevState);
        console.log("isClaimClosed", isClaimClosed);
    };









    const handlePrint = () => {
        window.print();
    }




    const tableRef = useRef('');


    const exportToExcel = () => {
        const pagename = 'ClaimStatus';
        const table = tableRef.current;
        let sPrintableData = table ? table.innerHTML : '';

        const vRegEx = new RegExp("gvClosedClaims", "");
        sPrintableData = sPrintableData.replace(vRegEx, "gvAcceptdClaims");

        console.log('Table HTML:', sPrintableData);

        const PrintableDataDetails = {
            PrintableData: sPrintableData,
            PageName: pagename,
        };

        const InputJSONLevelOne = JSON.stringify(PrintableDataDetails);
        const InputJSON = JSON.stringify(InputJSONLevelOne);

        console.log("Input of Excel", InputJSON);

        fetch(APIConstants.SERVICES_URL + FilesAPIConstants.ExcelFile, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: InputJSON,
        })
            .then(response => response.json()) // Parse the response as JSON
            .then(data => {
                console.log('API response:' + FilesAPIConstants.ExcelFile, data);

                if (data && data[2]) {

                    const url = data[2];
                    window.open(url, '_blank');

                }
            })
            .catch(error => {
                console.error('Export to Excel failed', error);
            });
    };





    const exportToPDF = () => {
        const pagename = 'ClaimStatus';
        const table = tableRef.current.parentNode;
        let sPrintableData = table ? table.innerHTML : '';

        const vRegEx = new RegExp("gvClosedClaims", "");
        sPrintableData = sPrintableData.replace(vRegEx, "gvAcceptdClaims");

        console.log('Table HTML:', sPrintableData);

        const PrintableDataDetails = {
            PrintableData: sPrintableData,
            PageName: pagename,
        };

        const InputJSONLevelOne = JSON.stringify(PrintableDataDetails);
        const InputJSON = JSON.stringify(InputJSONLevelOne);

        console.log("Input of Excel", InputJSON);

        fetch(APIConstants.SERVICES_URL + FilesAPIConstants.ExportPdfFile, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: InputJSON,
        })
            .then(response => response.json()) // Parse the response as JSON
            .then(data => {
                console.log('API response:' + FilesAPIConstants.ExportPdfFile, data);

                if (data && data[2]) {

                    const url = data[2];
                    window.open(url, '_blank');


                }
            })
            .catch(error => {
                console.error('Export to PDF failed', error);
            });
    };






    const fetchGetAllEvents = (item) => {

        setselectedClaimID(item.ClaimId)


        var inputJSON = {
            PracticeID: userPracticeID,
            ModuleName: "Billing",
            dtFromDate: startDate,
            dtToDate: endDate,
            DataID: item.ClaimId,
            UserID: 0,
            DateType: "DOS",

        }

        var sInputJSON = JSON.stringify(inputJSON);
        console.log("input of" + CommonAPIConstants.GetClaimAllEvents, sInputJSON);

        const url = `${APIConstants.COMMON_BASE_URL}${CommonAPIConstants.GetClaimAllEvents}?sJSONInput=${sInputJSON}`;

        console.log("URL: ", url);

        fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        })

            .then((response) => {
                if (response.status != 200) { console.log("response.status", response.status); }
                else return response.json();
            })
            .then(data => {



                const parsedData = JSON.parse(data);

                const patientData = parsedData.Data

                setEventData(patientData)

                setShowFaxModal(true)

                console.log(" ResponseData OF" + CommonAPIConstants.GetClaimAllEvents, patientData);



            })
            .catch((error) => {
                console.error('Error fetching patient names:', error);
            });
    };







    const GetPDFCMS = (item) => {

        console.log("PDF Data", item);


        const claimFilters = {

            PracticeID: userPracticeID,
            ClaimID: item.ClaimId,
            PatientID: item.PatientID,

        };


        const sInputJSON = JSON.stringify(claimFilters);

        console.log("Input of PDF" + CommonAPIConstants.GetPDFCMS1500, sInputJSON);

        const url = `${APIConstants.BASE_URL_BILLING}${CommonAPIConstants.GetPDFCMS1500}?sInputJSON=${sInputJSON}`;

        console.log("URL: ", url);

        fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        })

            .then(response => response.json()) // Parse the response as JSON
            .then(data => {
                console.log('API response:' + CommonAPIConstants.GetPDFCMS1500, data);

                if (data && data) {

                    const parsedData = JSON.parse(data)
                    const url = parsedData.DocumentURL
                    window.open(url, '_blank');


                }
            })
            .catch(error => {
                console.error(' PDF failed', error);
            });
    };






    const handleRegeneratePDFCMS = (item) => {
        const { ClaimId } = item;


        setRowState((prevState) => ({
            ...prevState,
            [ClaimId]: { isLoading: true, isHidden: false }
        }));

        const objClaim = {
            PatientID: item.PatientID,
            ClaimID: item.ClaimId,
            PracticeID: userPracticeID,
            isPriorSecClaim: item.PriorSecClaim,
        };

        console.log('userData', userData);
        const myInput = JSON.stringify(objClaim);
        console.log("Input of " + CommonAPIConstants.SaveRegeneratePDFCMS1500, myInput);

        fetch(APIConstants.BASE_URL + CommonAPIConstants.SaveRegeneratePDFCMS1500, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: myInput,
        })
            .then((response) => response.json())
            .then((data) => {
                console.log("Data of " + CommonAPIConstants.SaveRegeneratePDFCMS1500, data);

                setReGenerateData(data);

                // After the response, hide the icon and stop the loading
                setRowState((prevState) => ({
                    ...prevState,
                    [ClaimId]: { isLoading: false, isHidden: true },
                }));
            })
            .catch((error) => {
                console.error('An error occurred:', error);

                // In case of error, stop the loading but keep the icon visible for retry
                setRowState((prevState) => ({
                    ...prevState,
                    [ClaimId]: { isLoading: false, isHidden: false },
                }));
            });
    };







    const handleGetClaimSubmitHx = (item) => {



        const claimHx = item.ClaimHx;
        const [prefix, suffix] = claimHx ? claimHx.split('$') : [];


        const Patname = `${item.LastName},${item.FirstName}`;
        setselectedPatname(Patname)
        setselectedDOB(formatDOSDate(item.DOB))

        const objClaim = {

            iPracticeID: userPracticeID,
            sClaimID: item.ClaimId,
            ClaimHxIndicator: suffix,
            ClaimPriOrSec: item.PriorSecClaim



        }



        var sInputJSON = JSON.stringify(objClaim);
        console.log("input of" + CommonAPIConstants.GetClaimSubmitHx, sInputJSON);

        const url = `${APIConstants.BASE_URL_BILLING}${CommonAPIConstants.GetClaimSubmitHx}?sInputJSON=${sInputJSON}`;

        console.log("URL: ", url);

        fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        })

            .then((response) => {
                if (response.status != 200) { console.log("response.status", response.status); }
                else return response.json();
            })
            .then(data => {


                if (data) {
                    setShowDataModal(true)
                }

                console.log(" ResponseData OF" + CommonAPIConstants.GetClaimSubmitHx, data);



            })
            .catch((error) => {
                console.error('Error fetching patient names:', error);
            });
    };








    const handleDosLinkClick = (item) => {
        const url = `/#/transactionlogs/${item.ClaimId}?state=${encodeURIComponent(JSON.stringify(item))}`;
        window.open(url, '_blank');
    };


    const handleLinkClick = (item) => {
        const url = `/#/new-encounter/${item.ClaimId}`;
        window.open(url, '_blank');
    };



    const handlePatLinkClick = (item) => {
        const url = `/#/patient-dashboard/${item.PatientID}/primary-insurance`;

        localStorage.setItem("statusPatientID", item.PatientID);

        window.open(url, '_blank');
    };








    useEffect(() => {
        const filteredData = filteredTableDetails?.filter(item => {
            const dosDate = formatDOSDate(item.ClaimDOS);
            const dobDate = formatDOSDate(item.DOB);
            const submitDate = formatSubmitDate(item.SubmitDate);
            const secSubmitDate = formatSubmitDate(item.SecClaimSubmiDate);
            const paymentChequeDate = formatSubmitDate(item.PaymentChequeDate);
            const secCPTChequeDate = formatSubmitDate(item.SecCPTChequeDate);

            return (

                (dosDate ? dosDate.toLowerCase().includes(searchByDOS.toLowerCase()) : true) &&


                (item.ClaimId != null ? item.ClaimId.toString().toLowerCase().includes(searchByClaim.toLowerCase()) : true) &&


                (item.LastName ? item.LastName.toLowerCase().startsWith(searchByPatient.toLowerCase()) : true) &&


                (dobDate ? dobDate.toLowerCase().includes(searchByDOB.toLowerCase()) : true) &&


                (!searchByInsurance || (item.InsCompNickName && typeof item.InsCompNickName === 'string' && item.InsCompNickName.toLowerCase().includes(searchByInsurance.toLowerCase()))) &&


                (!searchBySecInsurance || (item.SecInsCompNickName && typeof item.SecInsCompNickName === 'string' && item.SecInsCompNickName.toLowerCase().includes(searchBySecInsurance.toLowerCase()))) &&


                (item.CPTOld ? item.CPTOld.toLowerCase().includes(searchByCPT.toLowerCase()) : true) &&


                (item.totalcharge != null ?
                    (searchByTotalCharge === '0' ? item.totalcharge === 0 : item.totalcharge.toString().toLowerCase().includes(searchByTotalCharge.toLowerCase())) :
                    true) &&



                (item.Adjustment !== undefined && (typeof item.Adjustment === 'string' || typeof item.Adjustment === 'number') ?
                    (searchByAdjustmentAmt === '0' ? item.Adjustment === 0 : item.Adjustment.toString().toLowerCase().includes(searchByAdjustmentAmt.toLowerCase())) :
                    true) &&


                (item.SecPendingAmt !== undefined && (typeof item.SecPendingAmt === 'string' || typeof item.SecPendingAmt === 'number') ?
                    (searchBySecPendingAmt === '0' ? item.SecPendingAmt === 0 : item.SecPendingAmt.toString().toLowerCase().includes(searchBySecPendingAmt.toLowerCase())) :
                    true) &&


                (!searchBySubmitdate || (submitDate && typeof submitDate === 'string' ?
                    submitDate.toLowerCase().includes(searchBySubmitdate.toLowerCase()) :
                    false)) &&


                (!searchBySecSubmitdate || (secSubmitDate && typeof secSubmitDate === 'string' ?
                    secSubmitDate.toLowerCase().includes(searchBySecSubmitdate.toLowerCase()) :
                    false)) &&



                (item.claimbln !== undefined && (typeof item.claimbln === 'string' || typeof item.claimbln === 'number') ?
                    (searchByBalance === '0' ? item.claimbln === 0 : item.claimbln.toString().toLowerCase().includes(searchByBalance.toLowerCase())) :
                    true) &&



                (item.ClearingHouseName ? item.ClearingHouseName.toLowerCase().includes(searchByClearingHouse.toLowerCase()) : true) &&








                (searchByRcvdCharge ?
                    (item.recvdCharge !== undefined && item.recvdCharge !== null &&
                        (searchByRcvdCharge === '0' ? item.recvdCharge === 0 :
                            item.recvdCharge.toString().toLowerCase().includes(searchByRcvdCharge.toLowerCase()))) :
                    true) &&


                (searchBySecRcvdCharge ?
                    (item.SecrecvdCharge !== undefined && item.SecrecvdCharge !== null &&
                        (searchBySecRcvdCharge === '0' ? item.SecrecvdCharge === 0 :
                            item.SecrecvdCharge.toString().toLowerCase().includes(searchBySecRcvdCharge.toLowerCase()))) :
                    true) &&




                (searchByDeductible ?
                    (item.Deductible !== undefined && item.Deductible !== null &&
                        (searchByDeductible === '0' ? item.Deductible === 0 :
                            item.Deductible.toString().toLowerCase().includes(searchByDeductible.toLowerCase()))) :
                    true) &&


                (searchByPatientRes ?
                    (item.PatientAmount !== undefined && item.PatientAmount !== null &&
                        (searchByPatientRes === '0' ? item.PatientAmount === 0 :
                            item.PatientAmount.toString().toLowerCase().includes(searchByPatientRes.toLowerCase()))) :
                    true) &&


                (searchByWriteOffValue ?
                    (item.WriteOffAmount !== undefined && item.WriteOffAmount !== null &&
                        (searchByWriteOffValue === '0' ? item.WriteOffAmount === 0 :
                            item.WriteOffAmount.toString().toLowerCase().includes(searchByWriteOffValue.toLowerCase()))) :
                    true) &&


                (searchByAdminWriteOffValue ?
                    (item.AdminwriteOff !== undefined && item.AdminwriteOff !== null &&
                        (searchByAdminWriteOffValue === '0' ? item.AdminwriteOff === 0 :
                            item.AdminwriteOff.toString().toLowerCase().includes(searchByAdminWriteOffValue.toLowerCase()))) :
                    true) &&



                (searchByCheckNum ?
                    (item.PaymentChqueNo !== undefined && item.PaymentChqueNo !== null &&
                        item.PaymentChqueNo.toString().toLowerCase().includes(searchByCheckNum.toLowerCase())) :
                    true) &&


                (searchByCheckDate ?
                    (paymentChequeDate !== null &&
                        paymentChequeDate.toLowerCase().includes(searchByCheckDate.toLowerCase())) :
                    true) &&


                (searchByPayerRef ?
                    (item.PayerRefNumber !== undefined && item.PayerRefNumber !== null &&
                        item.PayerRefNumber.toString().toLowerCase().includes(searchByPayerRef.toLowerCase())) :
                    true) &&


                (searchBySecCheckNum ?
                    (item.SecCPTChequeNumber !== undefined && item.SecCPTChequeNumber !== null &&
                        item.SecCPTChequeNumber.toString().toLowerCase().includes(searchBySecCheckNum.toLowerCase())) :
                    true) &&


                (searchBySecCheckDate ?
                    (secCPTChequeDate !== null &&
                        secCPTChequeDate.toLowerCase().includes(searchBySecCheckDate.toLowerCase())) :
                    true) &&


                (searchBySecPayerRef ?
                    (item.SecPayerclaimRefNumber !== undefined && item.SecPayerclaimRefNumber !== null &&
                        item.SecPayerclaimRefNumber.toString().toLowerCase().includes(searchBySecPayerRef.toLowerCase())) :
                    true) &&


                (item.UpdaterName && typeof item.UpdaterName === 'string' ? item.UpdaterName.toLowerCase().includes(searchByUpdatedBy.toLowerCase()) : true) &&


                (item.SubmitterName && typeof item.SubmitterName === 'string' ? item.SubmitterName.toLowerCase().includes(searchBySubmittedBy.toLowerCase()) : true) &&


                (item.providername && typeof item.providername === 'string' ? item.providername.toLowerCase().includes(searchByProvider.toLowerCase()) : true) &&


                (removeHtmlTags(item.ClaimStatusFlag) && typeof removeHtmlTags(item.ClaimStatusFlag) === 'string' ? removeHtmlTags(item.ClaimStatusFlag).toLowerCase().includes(searchByStatus.toLowerCase()) : true)
            );
        });


        setDisplayedRecords(
            searchByDOS || searchByPatient || searchByDOB || searchByInsurance || searchByClaim || searchByProvider ||
                searchBySecInsurance || searchByAdjustmentAmt || searchBySecPendingAmt ||
                searchByCPT || searchByTotalCharge || searchByRcvdCharge || searchByWriteOffValue ||
                searchByAdminWriteOffValue || searchBySubmitdate || searchBySecSubmitdate ||
                searchBySecRcvdCharge || searchBySecCheckNum || searchBySecCheckDate ||
                searchBySecPayerRef || searchByDeductible || searchByPatientRes || searchByUpdatedBy || searchBySubmittedBy ||
                searchByBalance || searchByCheckNum || searchByCheckDate || searchByStatus || searchByPayerRef || searchByClearingHouse
                ? filteredData : filteredTableDetails
        );
    }, [
        searchByDOS, searchByPatient, searchByDOB, searchByInsurance, searchByClaim, searchByProvider,
        searchByCPT, searchBySecInsurance, searchByAdjustmentAmt, searchBySecPendingAmt, searchByTotalCharge,
        searchByRcvdCharge, searchBySecRcvdCharge, searchByWriteOffValue, searchByAdminWriteOffValue,
        searchBySubmitdate, searchBySecSubmitdate, searchBySecCheckNum, searchBySecCheckDate, searchBySecPayerRef,
        searchByDeductible, searchByPatientRes, searchByUpdatedBy, searchBySubmittedBy, searchByBalance, searchByCheckNum,
        searchByCheckDate, searchByStatus, searchByPayerRef, searchByClearingHouse, filteredTableDetails
    ]);






    useEffect(() => {
        const filteredData = claimFilterRecCountsTableData?.filter(item =>
            (item.DOS && typeof item.DOS === 'string' ? item.DOS.toLowerCase().includes(searchByClaimDos.toLowerCase()) : true)


        );

        setClaimRecCountsTableData(
            searchByClaimDos ? filteredData : claimFilterRecCountsTableData
        );


        if (searchByClaimDos && filteredData.length > 0) {
            setShowDetails(true);
        } else {
            setShowDetails(false);
        }
    }, [searchByClaimDos, claimFilterRecCountsTableData]);







    const getRepeatedClaimIds = (records) => {
        const claimIdCount = {};
        records?.forEach((item) => {
            if (claimIdCount[item.ClaimId]) {
                claimIdCount[item.ClaimId] += 1;
            } else {
                claimIdCount[item.ClaimId] = 1;
            }
        });
        return claimIdCount;
    };

    // Get repeated ClaimIds for the displayed records
    const claimIdCount = getRepeatedClaimIds(displayedRecords);







    const handleVerifiedData = () => {



        let claimInput = []


        for (const rowIndex of selectedResubmitRows) {
            const item = tableDetails[rowIndex];

            var objClaim =
            {

                Comments: '',
                UserID: userId,
                ClaimID: item.ClaimId,
                PracticeID: userPracticeID
            }

            claimInput.push(objClaim)

            console.log('userData', userData);
            var myInput = JSON.stringify({ objClaim: claimInput });

            var myInputData = JSON.stringify(myInput)
            console.log("input of" + RemittanceConstants.GetVerifiedClaim, myInputData);


            const response = fetch(APIConstants.BASE_URL_BILLING + RemittanceConstants.GetVerifiedClaim, {
                method: 'POST',

                headers: {

                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${sAuthToken}`
                },

                body: myInputData
            })


                .then((data) => {

                    // const parsedData = JSON.parse(data);



                    if (data.ok) {
                        setDisableCheckboxes(true);
                    }




                    console.log("Data of " + RemittanceConstants.GetVerifiedClaim, data, data.ok);




                })
                .catch((error) => {
                    console.error('An error occurred:', error);

                })

        }

    };

    const getClaimAdjustment = (claimId) => {
        if (!adjustmentCodeData || adjustmentCodeData.length === 0) return null;

        const adj = adjustmentCodeData.find(
            a => String(a.ClaimID) === String(claimId)
        );

        if (!adj) return null;

        return (
            <label title={adj.ReasonDescription}>
                {adj.ClaimAdjustmentCode}
            </label>
        );
    };




    const Row = ({ index, style }) => {
        const item = displayedRecords[index];


        const { ClaimId } = item;

        const isClaimIdRepeated = claimIdCount[ClaimId] > 1;

        const rowLoading = rowState[ClaimId]?.isLoading || false;
        const rowHidden = rowState[ClaimId]?.isHidden || false;

        const claimHx = item.ClaimHx;
        const [prefix, suffix] = claimHx ? claimHx.split('$') : [];


        return (




            <tr className={`${activeRow === index ? 'table-warning' : ''} ${item.DataValidationMessage !== null && item.DataValidationMessage !== '' ? 'table-danger' : 'table-success'}`}
                style={{
                    ...style,

                    backgroundColor: item.DataValidationMessage && activeRow === index ? 'lightgoldenrodyellow'
                        : item.DataValidationMessage ? 'lightcoral'
                            : activeRow === index ? 'lightgoldenrodyellow'
                                : item.iClosed == 1 ? 'lightgrey'
                                    : ''
                }}
                data-toggle="tooltip"
                data-placement="top"
                title={item.DataValidationMessage || ''}
                key={index}
                onClick={() => handleRowClick(index)}

            >


                <td className='table-bordered border border-white' scope="row" style={{ fontFamily: 'sans-serif', fontSize: '14px', fontWeight: '500', width: '30px' }}>{index + 1}</td>
                <td className='table-bordered border border-white' style={{ width: '100px' }}><label className={getAppLoactionLabelClass(item.LocationNickname)}>{item.LocationNickname}</label></td>
                <td className='table-bordered border border-white' style={{ backgroundColor: isClaimIdRepeated ? 'gray' : '', width: '120px' }}><label className='linkspan' onClick={() => handleDosLinkClick(item)}>

                    {formatDOSDate(item.ClaimDOS)}</label></td>
                <td className='table-bordered border border-white' style={{ backgroundColor: isClaimIdRepeated ? 'gray' : '', width:'120px' }}>

                    <span onClick={() => handleLinkClick(item)} style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }}>
                        {item.ClaimId}
                    </span>

                </td>
                <td className='table-bordered border border-white' style={{ backgroundColor: isClaimIdRepeated ? 'gray' : '' }}>
                    <label className='linkspan' onClick={() => handlePatLinkClick(item)}>
                        {item.LastName},{item.FirstName}
                    </label>

                    {item.PatSecInscount > 0 && (
                        <span>
                            <FontAwesomeIcon style={{ marginLeft: '10px' }} icon={faShieldHalved} />
                        </span>
                    )}
                </td>

               
                <td className='table-bordered border border-white' style={{ width: '120px' }}><label className='label-style' >{formatSubmitDate(item.DOB)}</label></td>
                <td className={`table-bordered border border-white ${item.IsPrimarySkipped === true ? 'InsSkipped' : ''}`}><label className='label-style'>{item.InsCompNickName}</label>
                    <br />
                    <label>{item.PayerID}</label>

                    <span className={`payer${index}`}>
                        {item.PolicyNumber}
                    </span>
                    {item.IsPrimarySkipped === true && (
                        <div className="divSkipped">
                            Skipped
                        </div>
                    )}

                    {rowState[item.ClaimId]?.isHidden && (
                        <FontAwesomeIcon
                            style={{ marginLeft: '5px' }}
                            icon={faSpinner}
                            className={rowState[item.ClaimId]?.isLoading ? 'rotating-icon' : ''}
                        />
                    )}



                    <input type='checkbox' style={{ marginLeft: '5px' }}
                        checked={selectedPolicyRows.includes(index)}
                        onChange={() => handlePolicyRowCheckboxChange(index)}
                    />

                </td>
                <td className='table-bordered border border-white' style={{ backgroundColor: '#f1f1c4 !important' }}>
                    <label className='label-style'>{item.SecInsCompNickName}</label>
                    <br />

                    <label>{item.SecPayerID}</label>

                    <span className={`payer-id-${index}`}>
                        {item.SecInsPolicyNumber}
                    </span>

                    <input type='checkbox' style={{ marginLeft: '5px' }}
                        checked={selectedSecInsuranceRows.includes(index)}
                        onChange={() => handleSecInsuranceCheckboxChange(index)}
                    />

                </td>

                <td className='table-bordered border border-white'><label className='label-style'>{formatSubmitDate(item.SubmitDate)}</label></td>
                <td className='table-bordered border border-white'><label className='label-style'>{formatSubmitDate(item.SecClaimSubmiDate)}</label></td>
                <td className='table-bordered border border-white'>
                    <label>{item.ClaimStatus}</label>

                    <label title={getTooltip(item.ClaimStatusFlag)} dangerouslySetInnerHTML={{ __html: item.ClaimStatusFlag }}></label>

                </td>

                <td className='table-bordered border border-white'><label className='unpaid-claims' style={{ backgroundColor: item.recvdCharge !== null ? 'lightgreen' : 'lightgray' }}>{item.ClaimCPT}</label>

                </td>
                <td className='table-bordered border border-white' style={{ width: '100px' }}><label>{item.Units}</label>

                </td>
                <td className='table-bordered border border-white'><label>{item.totalcharge}</label></td>

                <td className='table-bordered border border-white'>
                    <input type='text' style={{ width: '60px', borderRadius: '5px', borderColor: 'lightgray', backgroundColor: item.recvdCharge !== null ? 'lightgreen' : 'white' }}
                        defaultValue={item.recvdCharge === null ? '' : item.recvdCharge}
                        onBlur={(e) => SaveClaimRecvdCharges(e.target.value, item, e)}

                    />
                </td>
                <td className='table-bordered border border-white'>
                    <input type='text' style={{ width: '60px', borderRadius: '5px', borderColor: 'lightgray', backgroundColor: item.SecrecvdCharge !== null ? 'lightgreen' : 'white' }}
                        defaultValue={item.SecrecvdCharge === null ? '' : item.SecrecvdCharge}
                        onBlur={(e) => SaveSecClaimRecvdCharges(e.target.value, item, e)}

                    />
                </td>


                <td className='table-bordered border border-white'>
                    $<input type='text' style={{ width: '60px', borderRadius: '5px', borderColor: 'lightgray', backgroundColor: item.Adjustment !== null ? 'lightgreen' : 'white' }}
                        defaultValue={item.Adjustment === null ? '' : item.Adjustment}
                        onBlur={(e) => SaveAdjustMentCharges(e.target.value, item, e)}

                    />
                </td>



                <td className='table-bordered border border-white'>
                    $<input type='text' style={{ width: '60px', borderRadius: '5px', borderColor: 'lightgray', backgroundColor: item.SecPendingAmt !== null ? 'lightgreen' : 'white' }}
                        defaultValue={item.SecPendingAmt === null ? '' : item.SecPendingAmt}
                        onBlur={(e) => SaveSecPendingCharges(e.target.value, item, e)}

                    />
                </td>


                <td className='table-bordered border border-white'>
                    <input id='' type='text' style={{
                        width: '60px', borderRadius: '5px', borderColor: 'lightgray',
                        backgroundColor: item.dDeductible !== null ? 'lightgray' : 'white'
                    }}
                        defaultValue={item.Deductible}
                        onBlur={(e) => SaveClaimdeductibleTemp(e.target.value, item, e)}
                    />
                </td>

                <td className='table-bordered border border-white'>
                    <input id='txtWrteoff' type='text' style={{
                        width: '60px', borderRadius: '5px', borderColor: 'lightgray',
                        backgroundColor: item.PatientAmount !== null ? 'lightgray' : 'white'
                    }}
                        defaultValue={item.PatientAmount}

                        onBlur={(e) => SavePatientResponsibility(e.target.value, item, e)}
                    />
                </td>


                <td className='table-bordered border border-white'>
                    <input id='txtWriteoff' type='text' style={{ width: '60px', borderRadius: '5px', borderColor: 'lightgray' }}
                        defaultValue={item.WriteOffAmount}
                        onBlur={(e) => SaveClaimWriteOffCharges(e.target.value, item)}
                    />

                    <input type='checkbox' style={{ marginLeft: '5px' }}
                        checked={selectedWriteOffRows.includes(index)}
                        onChange={() => handleWriteOffRowCheckboxChange(index)}
                    />
                </td>
                <td className='table-bordered border border-white'><label>{item.AdminWriteOff}</label>
                    <input type='checkbox' style={{ marginLeft: '5px' }}
                        checked={selectedAdminWriteRows.includes(index)}
                        onChange={() => handleAdminRowCheckboxChange(index)}
                    />
                </td>
                <td className='table-bordered border border-white'><label>{item.claimbln}</label>

                </td>


                <td className='table-bordered border border-white'>
                    <input id={`PaymentChqueNo_${index}`} type='text' style={{ width: '150px', borderRadius: '5px', backgroundColor: item.PaymentChqueNo !== null ? 'lightgray' : 'white' }}
                        defaultValue={item.PaymentChqueNo}

                        onBlur={(e) => SaveClaimCPTChequeNumber(e.target.value, item, e)}
                    />
                </td>

                <td className='table-bordered border border-white'>
                    <input type='date' style={{ width: '120px', borderRadius: '5px', borderColor: 'lightgray', backgroundColor: item.PaymentChequeDate !== null ? 'lightgray' : 'white' }}
                        placeholder=""
                        value={formatDateForInput(item.PaymentChequeDate)}
                        onChange={(e) => UpdateClaimChequeDate(e.target.value, item)}
                    />

                </td>
                <td className='table-bordered border border-white'>
                    <input id='PayerRefNumber' type='text' style={{ width: '150px', borderRadius: '5px', borderColor: 'lightgray', backgroundColor: item.PayerRefNumber !== null ? 'lightgray' : 'white' }}
                        defaultValue={item.PayerRefNumber}
                        onBlur={(e) => SaveClaimsPayerRefID(e.target.value, item, e)}
                    />
                </td>
                <td className='table-bordered border border-white'>

                    <input id={`SecCPTChequeNumber${index}`} type='text' style={{ width: '150px', borderRadius: '5px', backgroundColor: item.SecCPTChequeNumber !== null ? 'lightgray' : 'white' }}
                        defaultValue={item.SecCPTChequeNumber}
                        onBlur={(e) => SecSaveClaimCPTChequeNumber(e.target.value, item, e)}
                    />
                </td>

                <td className='table-bordered border border-white'>
                    <input type='date' style={{ width: '120px', borderRadius: '5px', borderColor: 'lightgray', backgroundColor: item.SecCPTChequeDate !== null ? 'lightgray' : 'white' }}
                        placeholder=""
                        value={formatDateForInput(item.SecCPTChequeDate)}
                        onChange={(e) => SecUpdateClaimChequeDate(e.target.value, item)}
                    />

                </td>
                <td className='table-bordered border border-white'>
                    <input id='SecPayerclaimRefNumber' type='text' style={{ width: '150px', borderRadius: '5px', borderColor: 'lightgray', backgroundColor: item.SecPayerclaimRefNumber !== null ? 'lightgray' : 'white' }}
                        value={item.SecPayerclaimRefNumber}
                        onChange={(e) => SecSaveClaimsPayerRefID(e.target.value, item)}
                    />
                </td>
                <td className='table-bordered border border-white'>{item.providername}</td>

                <td className='table-bordered border border-white'>{item.SubmitterName}</td>
                <td className='table-bordered border border-white'>
                    <div
                        style={{
                            display: "inline-block",
                            marginRight: "5px",
                            padding: "4px 8px",
                            backgroundColor: "#eef2f7",
                            borderRadius: "4px",
                            cursor: "pointer"
                        }}>
                        {getClaimAdjustment(item.ClaimId)}
                    </div>
                </td>
                <td className='table-bordered border border-white'>{item.Remarks}
                    <div className='claimremarks'></div>
                    <div className='claimremarks'></div>
                </td>



                <td className='table-bordered border border-white'>

                    <input style={{ marginLeft: '6px' }} type='checkbox'
                        key={index}
                        checked={selectedResubmitRows.includes(index)}
                        disabled={disableCheckboxes || item.isVerified === 1}
                        onChange={() => handleReSubmitCheckboxChange(index)}
                    />
                </td>



            </tr>





        );
    };





    function getTooltip(html) {
        const match = html.match(/data-title=['"]([^'"]+)['"]/);
        return match ? match[1] : '';
    }



    return (
        <>



            <div className='mainremit-container'>





                {loading && (
                    <div className="overlay">
                        <div className="spinner-container">
                            <div className="spinner-grow text-danger" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                            <div className="spinner-grow text-warning" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                            <div className="spinner-grow text-info" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    </div>
                )}




                <div className="table-container ">
                    <table className="main_table fixed-header table table-hover table-striped table-bordered border-secondary" ref={tableRef}>



                        <thead>

                            <tr className='align-top '  >

                                <th className=' border-white col-sm col-th  text-white' style={{ backgroundColor: '#0173b7', width: '30px' }}>#</th>
                                <th className=' border-white col col-th-style  text-white' style={{ backgroundColor: '#0173b7', width: '100px' }}>Location</th>
                                <th className=' border-white col col-th-style  text-white' style={{ backgroundColor: '#0173b7', width: '120px' }}>DOS
                                    <br />
                                    <input style={{ width: '100px', height: '30px', borderRadius: '5px' }} type='text' placeholder='Search'
                                        value={searchByDOS}
                                        onChange={(e) => setSearchByDOS(e.target.value)}
                                    />
                                </th>

                                <th className=' border-white col col-th-style  text-white' style={{ backgroundColor: '#0173b7', width:'120px'}}>Claim#
                                    <br />
                                    <input style={{ width: '100px', height: '30px', borderRadius: '5px' }} type='text' placeholder='Search'
                                        value={searchByClaim}
                                        onChange={(e) => setSearchByClaim(e.target.value)}
                                    />

                                </th>

                                <th className=' border-white col-sm col-th text-white ' style={{ backgroundColor: '#0173b7', }}>Patient Name

                                    <br />
                                    <input style={{ width: '100px', height: '30px', borderRadius: '5px' }}
                                        type='text'
                                        placeholder='Search'
                                        value={searchByPatient}
                                        onChange={(e) => setSearchByPatient(e.target.value)}
                                    />

                                </th>


                                <th className=' border-white col col-th-style  text-white' style={{ backgroundColor: '#0173b7', width: '120px' }}>DOB
                                    <br />
                                    <input style={{ width: '100px', height: '30px', borderRadius: '5px' }}
                                        type='text'
                                        placeholder='Search'
                                        value={searchByDOB}
                                        onChange={(e) => setSearchByDOB(e.target.value)}
                                    />
                                </th>


                                <th className=' border-white col col-th-style  text-white' style={{ backgroundColor: '#f1f1c4', }}>
                                    <a style={{ cursor: 'pointer', color: 'black', fontWeight: 'bold' }} >Insurance(Pri)</a>
                                    <br />


                                    <input style={{ width: '100px', height: '30px', borderRadius: '5px' }} type='text' placeholder='Search'
                                        value={searchByInsurance}
                                        onChange={(e) => setSearchByInsurance(e.target.value)}
                                    />

                                    <br />

                                    <button className='btn-style3 mt-2' onClick={(e) => handleCheckeligibility(e)}>Check</button>

                                    <input style={{ float: 'right', marginTop: '15px' }} type='checkbox' />


                                </th>

                                <th className=' border-white col col-th-style  text-white' style={{ backgroundColor: 'lightyellow' }}>
                                    <a style={{ cursor: 'pointer', color: 'black', fontWeight: 'bold' }} >Insurance(Sec)</a>
                                    <br />


                                    <input style={{ width: '100px', height: '30px', borderRadius: '5px' }} type='text' placeholder='Search'
                                        value={searchBySecInsurance}
                                        onChange={(e) => setSearchBySecInsurance(e.target.value)}
                                    />

                                    <br />

                                    <button className='btn-style3 mt-2' onClick={(e) => handleSecCheckeligibility(e)} >Check</button>

                                    <input style={{ float: 'right', marginTop: '15px' }} type='checkbox' />

                                </th>

                              

                                <th className=' border-white col col-th-style  text-white' style={{ backgroundColor: '#f1f1c4' }}>
                                    <label style={{ color: 'black', fontWeight: 'bold' }}>Submit Date(Pri)</label>
                                    <br />
                                    <input style={{ width: '100px', height: '30px', borderRadius: '5px' }}
                                        placeholder='Search'
                                        value={searchBySubmitdate}
                                        onChange={(e) => setSearchBySubmitdate(e.target.value)}
                                    />
                                </th>


                                <th className=' border-white col col-th-style  text-white' style={{ backgroundColor: 'lightyellow' }}>
                                    <label style={{ color: 'black', fontWeight: 'bold' }}>Submit Date(Sec)</label>

                                    <br />
                                    <input style={{ width: '100px', height: '30px', borderRadius: '5px' }}
                                        placeholder='Search'
                                        value={searchBySecSubmitdate}
                                        onChange={(e) => setSearchBySecSubmitdate(e.target.value)}
                                    />
                                </th>

                                <th className=' border-white col-sm col-th text-white ' style={{ backgroundColor: '#0173b7' }}>Status

                                    <br />
                                    <div className='d-flex'>
                                        <label className={`not-submit-style ${statusFilter === 0 ? 'active' : ''}`} title='Not-Submitted' onClick={() => handleStatusFilterChange(0)}>N</label>
                                        <label className={`denied-style ${statusFilter === 9 ? 'active' : ''}`} title='Denied' onClick={() => handleStatusFilterChange(9)}>D</label>
                                        <label className={`paid-style ${statusFilter === 1 ? 'active' : ''}`} title='Paid' onClick={() => handleStatusFilterChange(1)}>P</label>
                                        <label className={`forwarded-style ${statusFilter === 5 ? 'active' : ''}`} title='Forwarded' onClick={() => handleStatusFilterChange(5)}>F</label>
                                        <label className={`rejected-style ${statusFilter === 2 ? 'active' : ''}`} title='Rejected' onClick={() => handleStatusFilterChange(2)}>R</label>
                                    </div>
                                    <input style={{ width: '100px', height: '30px', borderRadius: '5px' }}
                                        placeholder='Search'
                                        value={searchByStatus}
                                        onChange={(e) => setSearchByStatus(e.target.value)}
                                    />

                                </th>


                                <th className=' border-white col col-th-style  text-white' style={{ backgroundColor: '#0173b7' }}>CPT
                                    <br />
                                    <div className=' unpaid-claims'>R</div>

                                    <input style={{ width: '100px', height: '30px', borderRadius: '5px', marginTop: '2px' }} type='text' placeholder='Search'
                                        value={searchByCPT}
                                        onChange={(e) => setSearchByCPT(e.target.value)}
                                    />


                                </th>

                                <th className=' border-white col col-th-style  text-white' style={{ backgroundColor: '#0173b7', width: '100px' }}>Units

                                </th>

                                <th className=' border-white col col-th-style  text-white' style={{ backgroundColor: '#0173b7' }}>Total Charge
                                    <br />
                                    <input style={{ width: '100px', height: '30px', borderRadius: '5px' }}
                                        placeholder='Search'
                                        value={searchByTotalCharge}
                                        onChange={(e) => setSearchByTotalCharge(e.target.value)}
                                    />
                                </th>



                                <th className=' border-white col-sm col-th text-white ' style={{ backgroundColor: '#f1f1c4', fontSize: '1.1rem' }}>
                                    <label style={{ color: 'black', fontWeight: 'bold' }}>Charge Recieved(Pri)</label>

                                    <br />
                                    <input style={{ width: '100px', height: '30px', borderRadius: '5px' }} type='text'
                                        placeholder='Search'
                                        value={searchByRcvdCharge}
                                        onChange={(e) => setSearchByRcvdCharge(e.target.value)}
                                    />

                                </th>


                                <th className=' border-white col-sm col-th text-white ' style={{ backgroundColor: 'lightyellow', fontSize: '1.1rem' }}>
                                    <label style={{ color: 'black', fontWeight: 'bold' }}>Charge Recieved(Sec)</label>

                                    <br />
                                    <input style={{ width: '100px', height: '30px', borderRadius: '5px' }} type='text'
                                        placeholder='Search'
                                        value={searchBySecRcvdCharge}
                                        onChange={(e) => setSearchBySecRcvdCharge(e.target.value)}
                                    />

                                </th>


                                <th className=' border-white col-sm col-th text-white ' style={{ backgroundColor: '#f1f1c4', fontSize: '1.1rem' }}>
                                    <label style={{ color: 'black', fontWeight: 'bold' }}>Contractual Adjustment</label>

                                    <br />
                                    <input style={{ width: '100px', height: '30px', borderRadius: '5px' }} type='text'
                                        placeholder='Search'
                                        defaultValue={searchByAdjustmentAmt}
                                        onChange={(e) => setSearchByAdjustmentAmt(e.target.value)}
                                    />

                                </th>


                                <th className=' border-white col-sm col-th text-white ' style={{ backgroundColor: 'lightyellow', fontSize: '1.1rem' }}>
                                    <label style={{ color: 'black', fontWeight: 'bold' }}>Secondary Pending</label>

                                    <br />
                                    <input style={{ width: '100px', height: '30px', borderRadius: '5px' }} type='text'
                                        placeholder='Search'
                                        defaultValue={searchBySecPendingAmt}
                                        onChange={(e) => setSearchBySecPendingAmt(e.target.value)}
                                    />

                                </th>


                                <th className=' border-white col-sm col-th text-white ' style={{ backgroundColor: '#0173b7' }}>Deductible
                                    <br />
                                    <input style={{ width: '120px', height: '30px', borderRadius: '5px' }} type='text'
                                        placeholder='Search'
                                        value={searchByDeductible}
                                        onChange={(e) => setSearchByDeductible(e.target.value)}
                                    />
                                </th>

                                <th className=' border-white col-sm col-th text-white ' style={{ backgroundColor: '#0173b7' }}>Pat Res
                                    <br />
                                    <input style={{ width: '120px', height: '30px', borderRadius: '5px' }} type='text'
                                        placeholder='Search'
                                        value={searchByPatientRes}
                                        onChange={(e) => setSearchByPatientRes(e.target.value)}
                                    />
                                </th>

                                <th className=' border-white col-sm col-th text-white ' style={{ backgroundColor: '#0173b7' }}>Write-off

                                    <br />
                                    <input style={{ width: '100px', height: '30px', borderRadius: '5px' }} type='text'
                                        placeholder='Search'

                                        value={searchByWriteOffValue}
                                        onChange={(e) => setSearchByWriteOffValue(e.target.value)}
                                    />
                                    <br />
                                    <input type='checkbox'
                                        checked={selectAllWriteOffChecked}
                                        onChange={() => handleWriteOffSelectAllChange('all')} />
                                    <button className='btn-style3' onClick={() => ClosclaimWithCPT()}>Close</button>

                                </th>

                                <th className=' border-white col-sm col-th text-white ' style={{ backgroundColor: '#0173b7' }}>Admin Write-off
                                    <br />
                                    <input style={{ width: '120px', height: '30px', borderRadius: '5px' }} type='text'
                                        placeholder='Search'

                                        value={searchByAdminWriteOffValue}
                                        onChange={(e) => setSearchByAdminWriteOffValue(e.target.value)}
                                    />

                                    <br />
                                    <input type='checkbox'
                                        checked={selectAllAdminWriteChecked}
                                        onChange={() => handleAdminSelectAllChange('all')} />
                                    <button className='btn-style3' onClick={handleOpenModal}>Write-off</button>

                                </th>

                                <th className=' border-white col-sm col-th text-white ' style={{ backgroundColor: '#0173b7' }}>Balance
                                    <br />
                                    <input style={{ width: '120px', height: '30px', borderRadius: '5px' }} type='text'
                                        placeholder='Search'
                                        value={searchByBalance}
                                        onChange={(e) => setSearchByBalance(e.target.value)}
                                    />
                                </th>

                                <th className=' border-white col-sm col-th text-white ' style={{ backgroundColor: '#f1f1c4', fontSize: '1.1rem' }}>
                                    <label style={{ color: 'black', fontWeight: 'bold' }}>Cheque #(Pri)</label>
                                    <br />
                                    <input style={{ width: '120px', height: '30px', borderRadius: '5px' }} type='text'
                                        placeholder='Search'
                                        value={searchByCheckNum}
                                        onChange={(e) => setSearchByCheckNum(e.target.value)}
                                    />
                                </th>

                                <th className=' border-white col-sm col-th text-white ' style={{ backgroundColor: '#f1f1c4', fontSize: '1.1rem' }}>
                                    <label style={{ color: 'black', fontWeight: 'bold' }}>Cheque Date(Pri)</label>
                                    <br />
                                    <input style={{ width: '120px', height: '30px', borderRadius: '5px' }} type='text'
                                        placeholder='Search'
                                        value={searchByCheckDate}
                                        onChange={(e) => setSearchByCheckDate(e.target.value)}

                                    />
                                </th>

                                <th className=' border-white col-sm col-th text-white ' style={{ backgroundColor: '#f1f1c4', fontSize: '1.1rem' }}>
                                    <label style={{ color: 'black', fontWeight: 'bold' }}>Payer Ref #(Pri)</label>
                                    <br />
                                    <input style={{ width: '120px', height: '30px', borderRadius: '5px' }} type='text'
                                        placeholder='Search'
                                        value={searchByPayerRef}
                                        onChange={(e) => setSearchByPayerRef(e.target.value)}

                                    />
                                </th>



                                <th className=' border-white col-sm col-th text-white ' style={{ backgroundColor: 'lightyellow', fontSize: '1.1rem' }}>
                                    <label style={{ color: 'black', fontWeight: 'bold' }}>Cheque #(Sec)</label>
                                    <br />
                                    <input style={{ width: '120px', height: '30px', borderRadius: '5px' }} type='text'
                                        placeholder='Search'
                                        value={searchBySecCheckNum}
                                        onChange={(e) => setSearchBySecCheckNum(e.target.value)}
                                    />
                                </th>

                                <th className=' border-white col-sm col-th text-white ' style={{ backgroundColor: 'lightyellow', fontSize: '1.1rem' }}>
                                    <label style={{ color: 'black', fontWeight: 'bold' }}>Cheque Date(Sec)</label>
                                    <br />
                                    <input style={{ width: '120px', height: '30px', borderRadius: '5px' }} type='text'
                                        placeholder='Search'
                                        value={searchBySecCheckDate}
                                        onChange={(e) => setSearchBySecCheckDate(e.target.value)}

                                    />
                                </th>

                                <th className=' border-white col-sm col-th text-white ' style={{ backgroundColor: 'lightyellow', fontSize: '1.1rem' }}>
                                    <label style={{ color: 'black', fontWeight: 'bold' }}>Payer Ref #(Sec)</label>
                                    <br />
                                    <input style={{ width: '120px', height: '30px', borderRadius: '5px' }} type='text'
                                        placeholder='Search'
                                        value={searchBySecPayerRef}
                                        onChange={(e) => setSearchBySecPayerRef(e.target.value)}

                                    />
                                </th>

                                <th className=' border-white col-sm col-th text-white ' style={{ backgroundColor: '#0173b7' }}>Provider
                                    <br />
                                    <input style={{ width: '120px', height: '30px', borderRadius: '5px' }} type='text'
                                        placeholder='Search'
                                        value={searchByProvider}
                                        onChange={(e) => setSearchByProvider(e.target.value)}
                                    />
                                </th>



                                <th className=' border-white col-sm col-th text-white ' style={{ backgroundColor: '#0173b7' }}>User
                                    <br />
                                    <input style={{ width: '120px', height: '30px', borderRadius: '5px' }} type='text' placeholder='Search'
                                        value={searchBySubmittedBy}
                                        onChange={(e) => setSearchBySubmittedBy(e.target.value)}
                                    />
                                </th>

                                <th className=' border-white col-sm col-th text-white ' style={{ backgroundColor: '#0173b7' }}>
                                    Adjustment / Denial /Rejection Code

                                </th>

                                <th className=' border-white col-sm col-th text-white ' style={{ backgroundColor: '#0173b7' }}>Remarks
                                    <br />
                                    <input style={{ width: '120px', height: '30px', borderRadius: '5px' }} type='text' placeholder='Search'

                                    />

                                </th>






                                <th className=' border-white col-sm col-th text-white ' style={{ backgroundColor: '#0173b7' }}><Link style={{ color: 'white' }} onClick={handleVerifiedData}>Verify</Link>
                                    <input style={{ marginLeft: '3px' }} type='checkbox'
                                        checked={selectAllResubmit}
                                        onChange={() => handleResubmitAllChange('all')} />

                                </th>




                            </tr>

                        </thead>


                        <tbody >

                            {displayedRecords?.length === 0 ? (

                                <tr>
                                    <td colSpan="6" style={{ textAlign: 'center', fontWeight: 'bolder' }}>No Records Found</td>
                                </tr>
                            ) : (



                                <td colSpan="10" style={{ borderColor: 'white', border: '1px solid lightblue' }}>

                                    <List

                                        height={400} // height of the list container
                                        itemCount={displayedRecords?.length}
                                        itemSize={60}
                                        width={'414%'} // width of the list container

                                    >

                                        {Row}
                                    </List>
                                </td>



                            )}





                            <tr style={{ backgroundColor: 'lightgray' }}>

                                <td className='table-bordered border border-white'></td>
                                <td className='table-bordered border border-white'>Total </td>
                                <td className='table-bordered border border-white rectext'></td>
                                <td className='table-bordered border border-white rectext'></td>
                                <td className='table-bordered border border-white rectext'></td>
                                <td className='table-bordered border border-white rectext'></td>
                                <td className='table-bordered border border-white rectext'></td>
                                <td className='table-bordered border border-white rectext'></td>
                                <td className='table-bordered border border-white rectext'></td>
                                <td className='table-bordered border border-white rectext'></td>
                                <td className='table-bordered border border-white rectext'></td>
                                <td className='table-bordered border border-white'></td>
                                <td className='table-bordered border border-white'> </td>
                                <td className='table-bordered border border-white'> </td>
                                <td className='table-bordered border border-white'>{totals.totalUnits}</td>
                                <td className='table-bordered border border-white'>${totals.totalSubmitted.toFixed(2)}</td>
                                <td className='table-bordered border border-white'>${totals.totalReceived.toFixed(2)}</td>
                                <td className='table-bordered border border-white'>${totals.totalSecReceived.toFixed(2)} </td>
                                <td className='table-bordered border border-white'>${totals.totalAdjustmentAmt.toFixed(2)} </td>
                                <td className='table-bordered border border-white'>${totals.totalSecPendingAmt.toFixed(2)} </td>
                                <td className='table-bordered border border-white'>${totals.totalDeductible.toFixed(2)} </td>
                                <td className='table-bordered border border-white'>${totals.totalPatientRes.toFixed(2)} </td>
                                <td className='table-bordered border border-white'>${totals.totalWriteOff.toFixed(2)} </td>
                                <td className='table-bordered border border-white'>${totals.totalAdminWriteOff.toFixed(2)} </td>
                                <td className='table-bordered border border-white'>${totals.totalBalance.toFixed(2)} </td>


                                <td className='table-bordered border border-white'> </td>
                                <td className='table-bordered border border-white'> </td>
                                <td className='table-bordered border border-white'> </td>
                                <td className='table-bordered border border-white'> </td>
                                <td className='table-bordered border border-white'> </td>
                                <td className='table-bordered border border-white'> </td>
                                <td className='table-bordered border border-white'> </td>
                                <td className='table-bordered border border-white'> </td>
                                <td className='table-bordered border border-white'> </td>
                                <td className='table-bordered border border-white'> </td>
                                <td className='table-bordered border border-white'> </td>
                                <td className='table-bordered border border-white'> </td>
                                <td className='table-bordered border border-white'> </td>
                                <td className='table-bordered border border-white'> </td>
                                <td className='table-bordered border border-white'> </td>
                            </tr>



                        </tbody>
                    </table>



                    {showConfirmSaveModal && (

                        <div className='adminwrite-fax mt-5' ref={modalRef}>
                            <label>Select Transaction Code</label>
                            <FontAwesomeIcon style={{ float: 'right', fontWeight: 'bolder', fontSize: '1.3rem' }} onClick={handleCloseModals} icon={faXmark} />
                            <br />
                            <select style={{ width: '400px', height: '25px', marginTop: '3px' }}
                                value={selectedTransactionCode}
                                onChange={(e) => setSelectedTransactionCode(e.target.value)}
                            >
                                {transactionCodes.map((item, index) => (

                                    <option value={item.TransactionCodeID}>{item.TransactionCodeDescription}</option>
                                ))}
                            </select>

                            <br />
                            <button className='btn-style3 mt-2' onClick={handleSaveClaimCPTAdminWriteOffCharges}>Submit</button>

                        </div>
                    )}




                    {showVerifiedSaveModal && (

                        <div className='verified-fax'>

                            <textarea placeholder='comments' style={{ width: '300px', height: '80px', borderRadius: '5px' }}
                                value={selectedVerifiedData}
                                onChange={(e) => setSelectedVerifiedData(e.target.value)}
                            />
                            <br />
                            <button className='btn-style3 mt-2' onClick={handleCloseModals} >Cancel</button>
                            <button className='btn-style3 mt-2' onClick={handleSaveVerifiedData}>Confirm</button>

                        </div>
                    )}

                </div>



                {showServiceErrorModal && (

                    <div className='alert-modal'>
                        <label></label>
                        <FontAwesomeIcon style={{ float: 'right', fontWeight: 'bolder', fontSize: '1.1rem', backgroundColor: 'red' }} onClick={handleCloseModals} icon={faXmark} />
                        <p>please select atleast one Filter from Service...</p>

                    </div>

                )}


                {showSelectErrorModal && (

                    <div className='alert-modal'>
                        <label></label>
                        <FontAwesomeIcon style={{ float: 'right', fontWeight: 'bolder', fontSize: '1.1rem', backgroundColor: 'red' }} onClick={handleCloseModals} icon={faXmark} />
                        <p>please select atleast one claim...</p>

                    </div>

                )}




                {showSuccessModal && (
                    <div className='alert-modal'>
                        <label></label>
                        <FontAwesomeIcon style={{ float: 'right', fontWeight: 'bolder', fontSize: '1.1rem', backgroundColor: 'red' }} onClick={handleCloseModals} icon={faXmark} />
                        <p>Selected Claim Successfully Closed</p>

                    </div>
                )}




                {showFaxModal && (

                    <Draggable>
                        <div className='dialog-box2'>


                            <table className="table" >

                                <thead>

                                    <tr>
                                        <td className='topnavsub'>
                                            <FontAwesomeIcon style={{ width: '18px', height: '18px', borderRadius: '999px', border: '1px solid black', float: 'right', fontWeight: 'bolder', fontSize: '0.9rem', backgroundColor: 'red', color: 'white' }}
                                                onClick={handleCloseModals} icon={faXmark} />

                                        </td>

                                    </tr>

                                    <tr >

                                        <td style={{ backgroundColor: '#ECF7FB' }} >   <label >Claim ID:  {selectedClaimID}  </label></td>

                                    </tr>

                                    <tr>

                                        <td>

                                            {eventData.map((item, index) => (
                                                <>


                                                    <div className='event-style' key={index}>
                                                        <label>{item.DataCurStatus}</label>
                                                        <br />
                                                        <label>{formatDOSDate(item.EventDateTime)}- {item.UserFName}</label>

                                                    </div>

                                                    {index < eventData.length - 1 && (

                                                        <FontAwesomeIcon style={{ fontWeight: 'bolder', fontSize: '1.8rem' }} icon={faArrowRight} />

                                                    )}
                                                </>
                                            ))}
                                        </td>
                                    </tr>

                                </thead>

                                <tbody>



                                </tbody>


                            </table>


                        </div>
                    </Draggable>


                )}







                {showDataModal && (

                    <Draggable>
                        <div className='dialog-box3 p-2' >

                            <div className='d-flex'>
                                <label style={{ fontFamily: 'sans-serif', fontWeight: '600' }}>Patient Name:
                                    <Link>{selectedPatname}</Link>
                                </label>

                                <label style={{ fontFamily: 'sans-serif', fontWeight: '600', marginLeft: '60px' }}>DOB: </label>

                                <label style={{ fontFamily: 'sans-serif', fontWeight: '500', marginLeft: '5px' }}>{selectedDOB}</label>


                                <div className='topnavsub2'>
                                    <FontAwesomeIcon style={{ width: '18px', height: '18px', borderRadius: '999px', border: '1px solid black', float: 'right', fontWeight: 'bolder', fontSize: '0.9rem', backgroundColor: 'red', color: 'white', marginLeft: '40px' }}
                                        onClick={handleCloseModals} icon={faXmark} />

                                </div>
                            </div>
                            <table className="table table-bordered border-secondary border-white" >

                                <thead>

                                    <tr>



                                    </tr>



                                    <tr>

                                        <th className='text-white  border-white' style={{ backgroundColor: '#0173b7', width: '30px', }}>#</th>


                                        <th className='col col-th-style  text-white  border-white' style={{ backgroundColor: '#0173b7', }}>Claim ID

                                        </th>


                                        <th className='col col-th-style  text-white  border-white' style={{ backgroundColor: '#0173b7' }} >DOS


                                        </th>

                                        <th className='col col-th-style  text-white  border-white' style={{ backgroundColor: '#0173b7', }}>Submit Date

                                        </th>


                                        <th className='col col-th text-white  border-white' style={{ backgroundColor: '#0173b7' }}><label style={{ width: '100px' }}>Submit By</label>

                                        </th>


                                    </tr>



                                </thead>



                            </table>

                        </div>
                    </Draggable>


                )}




            </div>




        </>
    )
}

export default RemittanceClaimCounts;